const translations = {
  en: {
    // Header
    home: 'Home',
    draws: 'Competitions',
    howItWorks: 'How it Works',
    signIn: 'Sign In',
    joinNow: 'Join Now',
    forgotPassword: 'Forgot password?',
    randomDrawCertLabel: 'Absolute transparency',
    randomDrawCertTitle: '100% random & certified draws',
    randomDrawCertDesc: 'Each draw is performed via a certified and independent random system — the result is public and verifiable. You have a total guarantee of fairness.',
    randomDrawCertCaption: 'Certified by randomdraws.com — verifiable online',
    moreOptions: 'More options (credit, promo code, details)',
    totalToPay: 'Total to pay',
    answerRequired: 'Mandatory question',
    payByCard: 'Pay by card',
    useMyCredit: 'Use my credit',
    balance: 'Balance',
    boughtLabel: 'bought',
    remainingLabel: 'remaining',
    limitReached: 'limit reached',
    ticketsLowercase: 'tickets',
    forgotPasswordTitle: 'Forgot your password?',
    forgotPasswordSubtitle: 'Enter your email — we will send you a secure link to set a new password.',
    sendResetLink: 'Send reset link',
    sending: 'Sending…',
    emailSentTitle: 'Email sent!',
    forgotPasswordSent: 'If this email is registered, you will receive a link to reset your password.',
    checkSpamTitle: 'Check your spam folder',
    checkSpam: 'The email may take 1-2 minutes. If you can\'t find it in your inbox, check spam/junk.',
    linkValidFor: 'The link is valid for 1 hour.',
    backToLogin: 'Back to login',
    rememberPassword: 'Remember your password?',
    emailRequired: 'Please enter your email address',
    errorOccurred: 'An error occurred',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordMismatch: 'Passwords do not match',
    myAccount: 'My Account',
    admin: 'Admin',
    signOut: 'Sign Out',
    adminPanel: 'Admin Panel',
    // Hero
    heroBadge: "UK's Premier Luxury Competition",
    heroTitle1: 'Win',
    heroTitle2: 'Extraordinary',
    heroTitle3: 'Prizes',
    heroDesc: 'Enter luxury competitions for a fraction of the price. Rolex, Hermès, Apple — your dream prize is one entry away.',
    viewActiveDraws: 'View Active Draws',
    featuredDraw: 'Featured Draw',
    worth: 'Worth',
    // How it Works
    howItWorksTitle: 'How It Works',
    howItWorksSubtitle: 'Three simple steps to win luxury prizes',
    step1Title: 'Create Your Account',
    step1Desc: 'Sign up in seconds with your email. Quick, simple, secure.',
    step2Title: 'Top Up Your Credit',
    step2Desc: 'Add credit to your account in £ — get up to +10% bonus on bigger top-ups. Or skip this and pay tickets directly by card.',
    step3Title: 'Choose Your Draw',
    step3Desc: 'Browse our exclusive draws and pick your dream prize.',
    step4Title: 'Answer & Enter',
    step4Desc: 'Answer a simple skill question, then pay with your credit OR directly by card.',
    step5Title: 'Win Your Dream',
    step5Desc: 'Winners are drawn fairly and transparently. Could be you!',
    // Trust
    securePayments: 'Secure Payments',
    sslEncrypted: 'SSL encrypted',
    ukCompliant: 'UK Compliant',
    fullyRegulated: 'Fully regulated',
    realWinners: 'Real Winners',
    verifiedDraws: 'Verified draws',
    instantCredits: 'Instant Credits',
    pointsAddedInstantly: 'Points added instantly',
    // Raffles
    activeDraws: 'Active Draws',
    dontMiss: "Don't miss your chance to win",
    drawsLive: 'draws live',
    allLiveDraws: 'All live competitions',
    unavailable: 'Unavailable',
    viewDraw: 'View draw',
    getYourTicket: 'Get your ticket',
    orUntilSoldOut: 'or until all tickets are sold out',
    value: 'Value',
    sold: 'sold',
    left: 'left',
    entry: 'entry',
    enterDraw: 'Enter Draw',
    hot: 'HOT',
    endingSoon: 'ENDING SOON',
    endsToday: 'Ends Today',
    liveCountdown: 'Ends In',
    days: 'days',
    hrs: 'hrs',
    min: 'min',
    sec: 'sec',
    ageGate18Plus: '18+ Verification',
    liveCompetitions: 'Live Competitions',
    process: 'Process',
    topUp: 'Top Up',
    hallOfWinners: 'Hall of Winners',
    quickActions: 'Quick Actions',
    welcomeBack: 'Welcome back',
    myAccount: 'My Account',
    wallet: 'Wallet',
    exclusivePerks: 'Exclusive Perks',
    copiedToClipboard: 'Copied to clipboard!',
    whatsappPrompt: 'Got a question? Chat with us!',
    whatsappEnableLabel: 'Enable WhatsApp badge',
    whatsappEnableHelp: 'Show floating WhatsApp button on left side of the site',
    whatsappNumberLabel: 'WhatsApp number (with country code)',
    whatsappNumberHelp: 'Use international format. Spaces and dashes are removed automatically.',
    whatsappMessageLabel: 'Pre-filled message (optional)',
    saving: 'Saving...',
    socialMediaLinks: 'Social Media Links (Footer)',
    socialMediaHelp: 'Configure URLs and visibility of social icons in the footer',
    socialLinksSaved: 'Social links saved',
    brandingTitle: 'Site Branding',
    brandingHelp: 'Customize logos, favicon and browser tab title. Changes apply instantly.',
    brandingTitleLabel: 'Browser tab title',
    brandingTitleHelp: 'Shown in the browser tab next to the favicon. Leave empty for default.',
    brandingMainLogo: 'Main logo (header)',
    brandingSmallLogo: 'Small logo (scrolled)',
    brandingFavicon: 'Favicon (browser tab)',
    brandingSaved: 'Branding saved & applied',
    upload: 'Upload',
    uploading: 'Uploading...',
    uploadSuccess: 'Image uploaded',
    fileTooBig: 'File too big (max 5MB)',
    resetToDefault: 'Reset to default',
    saveAndApply: 'Save & Apply',
    backups: 'Backups',
    legalPages: 'Legal Pages',
    siteTexts: 'Site Texts',
    payments: 'Payments',
    salesDashboard: 'Sales',
    whatsappContacts: 'WhatsApp Contacts',
    chooseTickets: 'Choose your tickets',
    orChooseAmount: 'Or choose:',
    seeAllPacks: 'See all available packs',
    availablePacks: 'Available packs',
    discountApplied: 'Discount applied!',
    ticket: 'ticket',
    paymentMethod: 'Payment',
    cost: 'Cost',
    paidWithCard: 'Card',
    paidWithPoints: 'Credit',
    stripePack: '💳 Stripe Purchase',
    vipSubscription: '👑 VIP Subscription',
    myPayments: 'My Payments',
    totalPaid: 'Total Paid',
    ticketPurchases: 'Ticket Purchases',
    otherPurchases: 'Packs & VIP',
    noPayments: 'No card payments yet',
    noPaymentsHint: 'Your card payments will appear here.',
    pointPack: 'Credit',
    vipSubscription2: 'VIP Subscription',
    raffleTickets: 'Raffle Tickets',
    paid: 'Paid',
    pending: 'Pending',
    status: 'Status',
    paymentsHint: 'All card payments (point packs, VIP, direct tickets) are listed here.',
    mySubscription: 'My Subscription',
    activeSubscription: 'Active Subscription',
    pointsPerMonth: 'Points / month',
    perYear: 'Per year',
    perMonth2: 'Per month',
    renewsOn: 'Renews on',
    yourBenefits: 'Your benefits',
    memberSince: 'Member since',
    changePlan: 'Change plan',
    cancelSubscription: 'Cancel subscription',
    cancelHint: 'If you cancel, you keep your VIP benefits until the end of the paid period.',
    noActiveSubscription: 'No active subscription',
    vipPromo: 'Become VIP to enjoy monthly points, priority access and exclusive perks.',
    discoverVip: 'Discover VIP subscriptions',
    confirmCancelSubscription: 'Are you sure you want to cancel your VIP subscription? You will keep your benefits until the end of the current period.',
    subscriptionCancelled: 'Subscription cancelled',
    active: 'Active',
    currentPlan: 'Current plan',
    alreadyActive: 'Already active',
    cancelToSwitch: 'Cancel to switch',
    cancelFirstHint: 'Cancel your current subscription first from your account before subscribing to another plan.',
    loginToParticipate: 'Sign in to participate',
    securePaymentInfo: '🔒 Secure payment by Stripe',
    // ── Express / passwordless participation ──
    participate: 'Participate',
    allUsersTab: 'All',
    expStepQuestion: 'Quick question',
    expStepInfo: 'Your details',
    expStepPay: 'Payment',
    expAnswerQuestion: 'Answer to continue',
    expContinue: 'Continue',
    expBack: 'Back',
    expWrongAnswer: 'Wrong answer, try again.',
    expSelectAnswer: 'Please select an answer.',
    expAlreadyClient: 'Already a customer? Sign in',
    expContinueAsGuest: 'Continue without an account',
    expSignInTitle: 'Sign in to your account',
    expSignInDesc: 'Enter your email, we will send you a 6-digit code.',
    expSendCode: 'Send me a code',
    expCodeSent: 'Code sent! Check your inbox.',
    expEnterCode: 'Enter the 6-digit code',
    expVerify: 'Verify & sign in',
    expResendCode: 'Resend a code',
    expFirstName: 'First name',
    expLastName: 'Last name',
    expEmail: 'Email',
    expPhone: 'Phone',
    expCountry: 'Country',
    expPostcode: 'Postcode',
    expAddress: 'Address',
    expCity: 'City',
    expSecureBanner: '🔒 Your details are secure and only used to deliver your prize.',
    expFillRequired: 'Please fill in all required fields.',
    expPayByCard: '💳 Pay by card',
    expContinueToPay: 'Continue to payment',
    expWelcomeBack: 'Welcome back',
    expNoPasswordHint: 'No password needed — you stay signed in on this device.',
    useMyCredit: 'Use my credit',
    confirmParticipation: 'Confirm my entry',
    participationConfirmed: 'Entry confirmed! 🎉',
    joinTitle: 'Join WINLUXOR',
    joinDesc: 'Enter your email — we will send you a 6-digit code. No password.',
    updateProfileTitle: 'Welcome aboard! 🎉',
    updateProfileDesc: 'Complete your profile now (optional) — it speeds up your future purchases.',
    saveProfile: 'Save my profile',
    skipForNow: 'Skip for now',
    profileSaved: 'Profile saved ✓',
    orDivider: 'or',
    googleContinue: 'Continue with Google',
    googleComingSoon: 'Google sign-in coming soon — being configured.',
    comingSoon: 'Soon',
    comingSoon: 'Coming Soon',
    comingSoonHint: 'Stay tuned! This raffle will be available soon.',
    comingSoonDetailHint: 'This raffle will soon be open to participation. Come back soon!',
    raffleStatusLabel: 'Raffle type',
    raffleStatusHelp: 'Choose whether this raffle is active or just announced for later.',
    statusActive: 'Active',
    statusActiveHelp: 'Tickets on sale. Price + countdown shown.',
    statusComingSoon: 'Coming Soon',
    statusComingSoonHelp: 'Announcement only. No price, no date, no purchase.',
    creditReceived: 'Credit received',
    youPay: 'You pay',
    payWithCredit: 'Pay with my credit',
    insufficientCredit: 'Insufficient credit',
    ticketPrice: 'Ticket price',
    ticketsMax: 'Max tickets',
    totalTickets: 'Max tickets',
    totalTicketsAvailable: 'Total tickets available',
    packEnabled: 'Pack enabled',
    packDisabled: 'Pack disabled',
    member: 'Member',
    memberLevelStandard: 'Standard',
    memberLevelBronze: 'Bronze',
    memberLevelSilver: 'Silver',
    memberLevelGold: 'Gold',
    backupTitle: 'Backups',
    backupSubtitle: 'Migration & Recovery',
    backupHelp: 'Download complete site snapshots (design + client data) and re-import them on any server. Everything you need for migration or disaster recovery.',
    backupDesignTitle: 'Design Backup',
    backupDesignItem1: 'Site settings & branding (logos, colors, titles)',
    backupDesignItem2: 'Raffles structure (titles, descriptions, packages)',
    backupDesignItem3: 'Point packs, VIP plans, promo codes',
    backupDesignItem4: 'Banners, newsletters, CMS pages',
    backupDesignItem5: 'All uploaded images (logos, raffle photos)',
    backupClientsTitle: 'Client Data Backup',
    backupClientsItem1: 'All user accounts (including admin)',
    backupClientsItem2: 'Points balance, transactions, history',
    backupClientsItem3: 'Raffle entries & participations',
    backupClientsItem4: 'Notifications, wins, subscriptions',
    backupClientsItem5: 'Chat messages, email queue, referrals',
    downloadDesignZip: 'Download Design ZIP',
    downloadClientsJson: 'Download Clients JSON',
    backupDownloaded: 'Backup downloaded',
    backupDownloadFailed: 'Download failed',
    preparing: 'Preparing...',
    restoreZone: 'Danger Zone — Restore',
    restoreHelp: 'Drop a backup file below. The system auto-detects the type (design ZIP or client JSON).',
    dropOrClick: 'Drop a backup file here, or click to browse',
    supportedFormats: 'Supported: .zip (design) or .json (clients) — up to 1 GB',
    removeFile: 'Remove',
    modeReplace: 'Replace (recommended)',
    modeReplaceHelp: 'Wipe existing collections and overwrite. Best for full migration.',
    modeMerge: 'Merge (keep existing)',
    modeMergeHelp: 'Add backup data without deleting current. Skips duplicates by ID.',
    confirmRestoreLabel: 'Type RESTORE to confirm',
    typeRestoreToConfirm: 'Type RESTORE to confirm',
    restoring: 'Restoring...',
    restoreNow: 'Restore now',
    restoreSuccess: 'Restore complete',
    restoreSuccessTitle: 'Restore completed',
    uploadsRestored: 'Files restored',
    status: 'Status',
    blocked: 'Blocked',
    active: 'Active',
    block: 'Block',
    unblock: 'Unblock',
    delete: 'Delete',
    view: 'View',
    confirmDelete: 'Delete user?',
    confirmBlock: 'Block user?',
    confirmUnblock: 'Unblock user?',
    deleteWarning: 'This action is permanent and cannot be undone.',
    deleteWarningDetail: 'The user account, all their entries, transactions and notifications will be deleted.',
    blockExplain: 'The user will not be able to log in until you unblock them. Their data is preserved.',
    unblockExplain: 'The user will be able to log in again immediately.',
    typeDeleteToConfirm: 'Type DELETE to confirm',
    deletePermanently: 'Delete permanently',
    userBlocked: 'User blocked',
    userUnblocked: 'User unblocked',
    userDeleted: 'User deleted',
    processing: 'Processing...',
    designate: 'Designate',
    designateWinner: 'Designate Winner',
    designateExplain: 'Pick the winner from the participant list. Once confirmed, the user will receive an in-app notification + a beautiful email. Raffle will be marked as completed.',
    searchParticipants: 'Search by name or email...',
    loadingParticipants: 'Loading participants...',
    noParticipantsYet: 'No participants for this raffle yet.',
    confirmWinner: 'Confirm winner & notify',
    winners: 'Winners',
    winnersAdminHelp: 'Manage all designated winners. Publish them once you\'ve handed over the prize and have the photos.',
    publishWinner: 'Publish (with photos)',
    publishWinnerDialog: 'Publish winner with photos',
    photosLabel: 'Photos of the handover',
    photosHelp: 'Upload 1 to 10 photos showing the winner with their prize.',
    testimonialLabel: 'Testimonial / message (optional)',
    publishNow: 'Publish now',
    publishing: 'Publishing...',
    winnerPublished: '✨ Winner published on /winners',
    atLeastOnePhoto: 'Please upload at least one photo',
    uploadPhotos: 'Upload photos',
    won: 'Won',
    designatedAt: 'Designated',
    publishedAt: 'Published',
    noPendingWinners: 'No pending winners',
    noPendingWinnersHelp: 'Designate a winner from the Raffles page first.',
    noPublishedWinners: 'No published winners yet',
    soldOut: 'Sold Out',
    loginTitle: 'Sign in',
    loginSubtitle: 'Use the email and password you created on WINLUXOR.',
    forgotShort: 'Forgot?',
    signingIn: 'Signing in…',
    notRegisteredYet: 'Not registered yet?',
    createAccount: 'Create account',
    createAccountSub: '30 seconds — free',
    alreadyRegistered: 'Already registered?',
    signIn: 'Sign in',
    welcomeWinluxor: 'Welcome to WINLUXOR',
    createAccountIntro: 'Create your free account to participate in the raffles.',
    createMyAccount30s: 'Create my account in 30 seconds',
    haveAccountLogin: 'I already have an account → sign in',
    verifyTicketTitle: 'Verify your ticket number',
    verifyTicketIntro: 'All our draws are performed via an independent random-draw service to guarantee full fairness. Click below, enter your ticket number and verify that it is part of the official draw.',
    verifyTicketCta: 'Verify my ticket',
    soldOutBig: 'All Tickets Sold',
    soldOutDetailHelp: 'No more tickets available. The draw will still take place at the scheduled time.',
    soldOutAdvancedDrawPending: 'Advanced draw following sold out. Date coming soon — check back later!',
    soldOutAdvancedDrawWithDate: 'Advanced draw! Discover the new date below.',
    advancedDrawLabel: 'Advanced draw',
    advancedDrawComingSoon: 'Date coming soon',
    advancedDrawComingSoonHelp: 'Check back soon to discover the new draw date.',
    advancedDrawDateLabel: 'Advanced draw date',
    advancedDrawDateHelp: 'Advanced draw after early sold out. Leave empty until you know the date: players will see "Date coming soon". Once set, a countdown is displayed.',
    advancedDrawDateMissing: 'No date entered — public UI shows "Advanced draw · Date coming soon".',
    advancedDrawDateSet: 'Countdown active until this date on the public page.',
    clearDate: 'Clear date',
    // Per-raffle email actions (admin)
    resendLaunchEmail: 'Re-send launch email to all clients',
    sendUrgencyEmail: 'Send urgency email (tickets left)',
    resendSoldOutEmail: 'Re-send "Sold out — draw brought forward" email to participants',
    resendDrawDateEmail: 'Re-send "Draw date announced" email to participants',
    confirmResendLaunch: 'Re-send the launch email of this raffle to ALL clients?',
    confirmSendUrgency: 'Send an URGENCY email with photo + big headline "Only X tickets left available"?',
    confirmResendSoldOut: 'Re-send the "Sold out — advanced draw, date coming soon" email to PARTICIPANTS?',
    confirmResendDrawDate: 'Re-send the "Draw date announced" email to PARTICIPANTS with countdown?',
    noDrawDateSet: 'No draw date configured. Set it first.',
    noTicketsLeft: 'No tickets left. Use "Re-send launch email" instead.',
    ticketsLeftLabel: 'tickets left',
    emailQueuedSuffix: 'email(s) queued for sending',
    participantsEmailedSuffix: 'participant(s) notified',
    marketingOptions: 'Marketing & Status',
    featuredHomeLabel: 'Featured on Homepage Hero',
    featuredHomeHelp: 'Only one raffle can be featured at a time. Marking this one will unmark any other.',
    forceSoldOutLabel: 'Force Sold Out',
    forceSoldOutHelp: 'Manually mark as sold out (stops new ticket purchases). Countdown to draw stays visible.',
    displayedSoldTicketsLabel: 'Displayed sold tickets (override)',
    displayedSoldTicketsHelp: 'Optional. If set, public site shows this number instead of the real one (psychological boost). Real sold count is preserved.',
    leaveEmptyForReal: 'Leave empty to show real count',
    drawn: 'Drawn',
    disabled: 'Disabled',
    winnerDrawn: 'Winner drawn',
    ended: 'Ended',
    markRead: 'Mark read',
    winnerNotifTitle: 'Congratulations! You won',
    winnerNotifMessage: 'You are the winner of {{raffle}} — worth £{{value}}. Our team will contact you within 48 hours.',
    // Common toast / confirm
    toastUpdated: 'Updated',
    toastCreated: 'Created',
    toastDeleted: 'Deleted',
    toastSaved: 'Saved',
    toastFailed: 'Action failed',
    toastUploadFailed: 'Upload failed',
    confirmDeleteShort: 'Delete?',
    confirmDeleteRaffle: 'Delete this raffle?',
    confirmDeleteUser: 'Delete this user?',
    confirmDeleteWinner: 'Delete this winner record? The raffle will be re-opened for re-draw.',
    confirmUnpublishWinner: 'Unpublish this winner (back to pending)?',
    confirmAutoDraw: 'Auto-draw a random winner from entries? This cannot be undone.',
    confirmSendNewsletter: 'Send this newsletter to ALL users?',
    raffleUpdated: 'Raffle updated',
    raffleUpdatedEmailSent: 'Raffle updated — email sent to participants',
    notifyParticipantsTitle: 'Notify participants?',
    notifyParticipantsDesc: 'This change (draw date / sold out) can be announced by email to all participants. Do you want to send it?',
    saveWithoutEmail: 'Save without email',
    saveAndSendEmail: 'Save and send email',
    relanceEmail: 'Reminder email',
    relanceEmailTitle: 'Reminder email',
    relanceEmailDesc: 'How many remaining tickets do you want to display in the email? You will then see an exact preview before sending.',
    ticketsLeftToDisplay: 'Tickets left shown in the email',
    realTicketsLeft: 'Actually remaining',
    seeEmailPreview: 'See email preview',
    invalidTicketCount: 'Invalid number',
    raffleCreated: 'Raffle created',
    questionImageUploaded: 'Question image uploaded',
    imagesUploaded: 'image(s) uploaded',
    enterImageUrl: 'Enter image URL:',
    featuredRemoved: 'Removed from featured',
    featuredAdded: '⭐ Marked as featured',
    spinSaved: 'Spin wheel settings saved!',
    vipPlansSaved: 'VIP plans saved',
    enterValidAmount: 'Enter a valid amount',
    bothFieldsRequired: 'Both fields required',
    passwordUpdated: 'Password updated',
    winnerUnpublished: 'Winner unpublished',
    winnerDeletedReopen: 'Deleted, raffle re-opened',
    newsletterCreated: 'Newsletter created',
    subjectRequired: 'Subject is required',
    emailSettingsSaved: 'Email settings saved',
    photoUploaded: 'photo(s) uploaded',
    designateWinnerToast: '🏆 Winner designated! User notified by email + in-app.',
    drawSuccess: '🏆 Winner drawn',
    designateExplainerTitle: 'Pick the winner',
    drawScheduledIn: 'Draw scheduled in',
    exportTickets: 'Export tickets CSV',
    exportSuccess: 'Tickets exported',
    closeRaffleNow: 'Close raffle now',
    confirmCloseRaffle: 'Close this raffle now? Sales will stop and you can draw the winner.',
    raffleClosedToast: 'Raffle closed (sales stopped)',
    public: 'Public',
    hidden: 'HIDDEN',
    hide: 'Hide',
    hideFromPublic: 'Hide from public',
    hideRaffle: 'Hide (test mode)',
    showRaffle: 'Make visible',
    raffleNowHidden: '🙈 Raffle hidden (admins only)',
    raffleNowVisible: '✅ Raffle now visible publicly',
    defaultPhotos: 'Default photos',
    editHandoverPhotos: 'Edit photos / message',
    winnerUpdated: '✨ Winner updated',
    addManualWinner: 'Add a winner',
    manualWinnerHelp: 'For an off-site winner (social media, other prizes). All fields are optional.',
    winnerName: 'Winner name',
    prizeWon: 'Prize won',
    winningTicket: 'Ticket no.',
    addWinner: 'Add winner',
    winnerCreated: '🏆 Winner added',
    allWinners: 'All Winners',
    noWinnersYet: 'No winners yet',
    noHiddenWinners: 'No hidden winners',
    limitedBadge: '🔥 Limited',
    luckyOnesBadge: 'Lucky Ones',
    maxPerUserField: 'Max tickets per player',
    maxPerUserHelp: 'Set a hard cap on how many tickets a single user can buy on this raffle. Leave empty or 0 for unlimited.',
    unlimited: '0 = unlimited',
    maxPerUserLabel: 'Max tickets per player',
    ticketsLowercase: 'tickets',
    maxPerUserSuffix: 'maximum on this raffle',
    youHave: 'You have',
    youCanStillBuy: 'You can still buy',
    limitReached: 'Limit reached.',
    youCanBuyUpTo: 'You can buy up to',
    myTicketsTitle: 'Your Tickets',
    yourTicketNumbers: 'Your ticket numbers',
    ticketsTip: 'Each number is unique. The winning ticket number will be drawn from all participating tickets at the scheduled date.',
    ticketsPlural: 'tickets',
    clickToSeeTickets: 'Click any row to see your ticket numbers',
    testimonialDialogTitle: 'Share your experience!',
    testimonialDialogDesc: 'Tell future winners how it feels — your testimonial will be displayed (after admin review) on the Winners page.',
    testimonialLabel2: 'Your testimonial',
    testimonialPlaceholder: "e.g. 'I never thought I'd actually win — this prize is a dream! Thank you WINLUXOR!'",
    testimonialHint: 'Min 5, max 1000 characters. Will be reviewed by our team before going public.',
    testimonialTooShort: 'Please write at least 5 characters',
    testimonialSubmitted: '✨ Submitted for review!',
    testimonialThanks: 'Thank you!',
    testimonialThanksDesc: "Your testimonial has been submitted to our team for review. It will appear on the public Winners page once approved.",
    submitTestimonial: 'Submit',
    submitting: 'Submitting...',
    later: 'Later',
    testimonialPending: 'Testimonial pending review',
    reviewTestimonial: 'Review & approve',
    reviewTestimonialTitle: 'Review testimonial',
    reviewTestimonialHelp: 'You can edit the text below to fix typos before approving. The user will be notified once approved.',
    originalText: 'Original text submitted by user',
    finalText: 'Final text (editable)',
    approve: 'Approve & Publish',
    reject: 'Reject',
    testiApproved: '✓ Testimonial approved',
    testiRejected: 'Testimonial rejected (user notified)',
    byTicketCode: 'By winning ticket code',
    byTicketCodeHelp: 'Paste the code returned by your draw system',
    manualSelection: 'Manual selection',
    manualSelectionHelp: 'Pick a user and a specific ticket',
    winningTicketCode: 'Winning ticket code',
    winningTicketCodeHelp: 'Enter the code returned by your external draw system. The system will automatically find the user who owns this ticket.',
    selectTheirTicket: 'Select their winning ticket',
    selectUser: 'Select a participant',
    codeRequired: 'Enter a winning ticket code',
    winningTicket: 'Winning ticket',
    youAreTheWinner: 'You are the winner!',
    ticketLabel: 'Ticket',
    testimonialAwaiting: 'Testimonial coming soon...',
    swipeToSee: 'Swipe to see more',
    useTemplate: 'Use template',
    availableTemplates: 'Available templates',
    saveAsTemplate: 'Save as template',
    saveAsTemplateHelp: 'Save current packages as a reusable template',
    templateApplied: 'Template applied',
    templateSaved: 'Template saved',
    templateNamePrompt: 'Template name (e.g. "Standard 5/20/50/100"):',
    confirmDeleteTemplate: 'Delete this template?',
    noPackagesToSave: 'No packages to save',
    noPackagesYet: 'No packages yet. Add manually with "+ Add package" or apply a template.',
    option1: 'Option 1',
    option2: 'Option 2',
    buyPointsOption: 'Top up credit',
    buyPointsOptionDesc: 'Add credit to your account and get up to +15% bonus on bigger top-ups.',
    buyPointsBonus: 'Get up to +30% bonus points on bigger packs!',
    fast: 'Fast',
    seePacks: 'See packs',
    buyTicketDirectOption: 'Buy a ticket directly',
    buyTicketDirectDesc: 'No need to top up — pick a draw and grab tickets in one click. Pay & enter.',
    seeDraws: 'See draws',
    maxParticipants: 'Max Participants',
    maxParticipantsHelp: 'Limited entries — strong winning odds',
    maxWinnersLabel: 'Max Winners',
    maxWinnersHelp: 'Lucky winner(s) selected by random draw',
    // Urgency
    urgencyTitle: "Tonight's draws close soon",
    urgencyDesc: "Secure your entries before it's too late.",
    enterNow: 'Enter Now',
    // Winners
    recentWinners: 'Recent Winners',
    realPeopleRealPrizes: 'Real people, real prizes',
    prizesWonLabel: 'Prizes won',
    welcomeOfferShort: 'welcome',
    welcomeOfferApplied: 'Welcome offer applied',
    welcomeBannerText: '🎁 £{amount} off your first entry — claim it now',
    welcomeOfferTitle: 'Welcome offer',
    welcomeOfferHelp: 'Auto discount on the 1st participation (once per account).',
    welcomeOfferAmount: 'Amount (£)',
    welcomeOfferMin: 'Min spend (£)',
    verifiedWinner: 'Verified Winner',
    won: 'Won',
    // Packs
    pointPacks: 'Top Up Credit',
    buyPointsDesc: 'Top up your credit and enter the draws you love',
    mostPopular: 'Most Popular',
    pts: '£',
    bonus: 'bonus',
    buyPoints: 'Top Up',
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faq1q: 'How does WINLUXOR work?',
    faq1a: 'Purchase points, choose a draw, and enter for a chance to win luxury prizes. Each entry gives you a fair chance of winning. Winners are selected through a transparent random draw.',
    faq2q: 'How are winners selected?',
    faq2a: 'Winners are selected through a certified random number generator. Each entry has an equal chance of winning, and the entire process is transparent and auditable.',
    faq3q: 'What happens when I win?',
    faq3a: "We'll notify you immediately via email and phone. Your prize will be shipped to you free of charge within 5-7 business days, fully insured.",
    faq4q: 'Is there a free entry method?',
    faq4a: 'Yes! In compliance with UK law, you can enter any draw for free by sending a postal entry. Details are available in our Terms & Conditions.',
    faq5q: 'How do I buy points?',
    faq5a: 'Simply create an account, navigate to Point Packs, and choose the pack that suits you. We accept all major payment methods.',
    faq6q: 'Is WINLUXOR legitimate?',
    faq6a: 'Absolutely. WINLUXOR is a UK-registered company operating in full compliance with UK competition law. All draws are independently verified.',
    // Footer
    footerDesc: "The UK's premier luxury competition platform. Win extraordinary prizes for a fraction of their value.",
    quickLinks: 'Quick Links',
    legal: 'Legal',
    support: 'Support',
    termsAndConditions: 'Terms & Conditions',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
    responsiblePlay: 'Responsible Play',
    allRightsReserved: 'All rights reserved.',
    ageDisclaimer: '18+ only. Please play responsibly.',
    // Auth
    welcomeBack: 'Welcome Back',
    signInToAccount: 'Sign in to your WINLUXOR account',
    email: 'Email',
    password: 'Password',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    createAccount: 'Create Account',
    joinWinluxor: 'Join WINLUXOR and start winning luxury prizes',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    city: 'City',
    postcode: 'Postcode',
    gender: 'Gender',
    dateOfBirth: 'Date of Birth',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    preferNotToSay: 'Prefer not to say',
    creatingAccount: 'Creating account...',
    signingIn: 'Signing in...',
    adminAccess: 'Admin Access',
    signInToAdmin: 'Sign in to the WINLUXOR admin panel',
    username: 'Username',
    adminLogin: 'Admin login',
    // Raffle detail
    backToDraws: 'Back to Draws',
    endsIn: 'Ends in',
    entriesSold: 'entries sold',
    entriesRemaining: 'entries remaining',
    pointsPerEntry: 'per entry',
    confirmEntry: 'Confirm Entry',
    enterTheDrawFor: 'Enter the draw for',
    pricePerEntry: 'Price per entry',
    quantity: 'Quantity',
    total: 'Total',
    yourBalance: 'Your balance',
    insufficientPoints: 'Insufficient points',
    cancel: 'Cancel',
    confirm: 'Confirm',
    processing: 'Processing...',
    drawEnded: 'Draw Ended',
    soldOut: 'Sold Out',
    details: 'Details',
    shipping: 'Shipping',
    rules: 'Rules',
    shippingInfo: 'All prizes are shipped free of charge within 5-7 business days after the draw. Fully insured delivery within the UK. International shipping available upon request.',
    // Wallet
    yourBalanceLabel: 'Your Balance',
    points: '£',
    pointEquivalent: '£1 = 1 point',
    transactionHistory: 'Transaction History',
    noTransactions: 'No transactions yet',
    credit: 'Credit',
    debit: 'Debit',
    paymentComingSoon: 'Payment integration coming soon! Contact admin for points.',
    paymentInfo: 'Payment integration coming soon. Contact admin to credit points.',
    // Promo code (shared component)
    promoCodeLabel: 'Promo code',
    promoCodePlaceholder: 'WELCOME10',
    promoEmptyError: 'Please enter a promo code',
    promoApplied: 'Promo code applied!',
    promoCodeApplied: 'Code applied!',
    promoInvalid: 'Invalid promo code',
    promoDiscount: 'Discount',
    optional: 'optional',
    apply: 'Apply',
    type: 'Type',
    description: 'Description',
    amount: 'Amount',
    date: 'Date',
    // Account
    myEntries: 'My Entries',
    profile: 'Profile',
    noEntries: 'No entries yet. Enter a draw to get started!',
    draw: 'Draw',
    entries: 'Entries',
    pointsSpent: 'Amount',
    profileDetails: 'Profile Details',
    edit: 'Edit',
    save: 'Save',
    saveChanges: 'Save changes',
    completeProfileTitle: 'Complete your profile',
    completeProfileDesc: 'Add your phone number and address to finalise your entries and the delivery of your prizes.',
    completeProfileCta: 'Complete',
    saving: 'Saving...',
    profileUpdated: 'Profile updated',
    referralCode: 'Your Referral Code',
    // Admin
    dashboard: 'Dashboard',
    raffles: 'Raffles',
    users: 'Users',
    settings: 'Settings',
    backToSite: 'Back to Site',
    welcomeAdmin: 'Welcome back, Admin',
    totalUsers: 'Total Users',
    activeRaffles: 'Active Raffles',
    totalRaffles: 'Total Raffles',
    totalEntries: 'Total Entries',
    pointsInCirculation: 'Points in Circulation',
    revenuePoints: 'Revenue (Points)',
    newRaffle: 'New Raffle',
    manageDraws: 'Manage your draws',
    title: 'Title',
    tickets: 'Tickets',
    status: 'Status',
    drawn: 'Drawn',
    actions: 'Actions',
    active: 'Active',
    disabled: 'Disabled',
    winnerDrawn: 'Winner drawn',
    newPack: 'New Pack',
    managePacksDesc: 'Manage point packs and pricing',
    name: 'Name',
    price: 'Price',
    popular: 'Popular',
    enabled: 'Enabled',
    settingsDesc: 'Configure platform features and admin settings',
    homepageSections: 'Homepage Sections',
    activeDrawsSection: 'Active Draws Section',
    pointPacksSection: 'Credit Packs',
    winnersSection: 'Winners Section',
    urgencySection: 'Urgency/Marketing Section',
    howItWorksSection: 'How It Works Section',
    trustSection: 'Trust/Reassurance Section',
    faqSection: 'FAQ Section',
    saveSettings: 'Save Settings',
    changeAdminPassword: 'Change Admin Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    updatePassword: 'Update Password',
    platformInfo: 'Platform Info',
    currency: 'Currency',
    pointRate: 'Point Rate',
    adminUsername: 'Admin Username',
    creditDebitPoints: 'Credit / Debit Points',
    user: 'User',
    currentBalance: 'Current balance',
    amountHelp: 'Amount (positive = credit, negative = debit)',
    reason: 'Reason',
    searchUsers: 'Search users...',
    manageUsersDesc: 'Manage users and points',
    role: 'Role',
    joined: 'Joined',
    productValue: 'Product Value',
    ticketCostPoints: 'Ticket Cost (Points)',
    maxTickets: 'Max Tickets',
    category: 'Category',
    endDate: 'End Date',
    imageUrls: 'Image URLs (one per line)',
    watches: 'Watches',
    handbags: 'Handbags',
    jewelry: 'Jewelry',
    electronics: 'Electronics',
    vehicles: 'Vehicles',
    update: 'Update',
    create: 'Create',
    editRaffle: 'Edit Raffle',
    editPack: 'Edit Pack',
    bonusPct: 'Bonus %',
    select: 'Select',
    showTicketsSold: 'Show Tickets Sold on Raffles',
    // Phase 3
    winnersHistory: 'Winners & History',
    completedDraws: 'Completed Draws',
    noCompletedDraws: 'No completed draws yet.',
    drawnOn: 'Drawn on',
    winner: 'Winner',
    questionRequired: 'Answer the question to enter',
    answerQuestion: 'Answer the Question',
    submitAnswer: 'Submit Answer',
    incorrectAnswer: 'Incorrect answer. Please try again.',
    vipLevel: 'VIP Level',
    vipBronze: 'Bronze',
    vipSilver: 'Silver',
    vipGold: 'Gold',
    vipMember: 'Member',
    applyReferral: 'Apply Referral Code',
    referralPlaceholder: 'Enter referral code',
    apply: 'Apply',
    referralBonus: 'Referral Bonus',
    questionSetup: 'Question (Optional)',
    questionText: 'Question',
    answer: 'Answer',
    correctAnswer: 'Correct Answer',
    enableQuestion: 'Enable Question',
    referralBonusPoints: 'Referral Bonus (Points)',
    // Age verification
    ageVerificationTitle: 'Age Verification',
    ageVerificationDesc: 'You must be 18 years or older to access this website. By entering, you confirm that you meet the minimum age requirement.',
    ageYes: 'Yes, I am 18+',
    ageNo: 'No, I am under 18',
    // Promo codes
    promoCodes: 'Promo Codes',
    managePromosDesc: 'Manage promotional codes and discounts',
    newPromo: 'New Promo Code',
    editPromo: 'Edit Promo Code',
    code: 'Code',
    discountPct: 'Discount %',
    bonusPointsLabel: 'Bonus Points',
    maxUses: 'Max Uses',
    usedCount: 'Used',
    unlimited: 'unlimited',
    signupBonus: 'Signup Bonus (Points)',
    loyaltyBonusPct: 'Loyalty Bonus %',
    totalParticipants: 'total entries',
    myWins: 'My Wins',
    noWins: 'No wins yet. Keep entering!',
    notifications: 'Notifications',
    noNotifications: 'No notifications',
    unread: 'Unread',
    // Notification content (by type)
    notifEntryTitle: 'Entry Confirmed',
    notifEntryMessage: 'You entered {{raffle}} with {{qty}} ticket(s). Good luck!',
    notifNewRaffleTitle: 'New Competition!',
    notifNewRaffleMessage: '{{raffle}} — Worth £{{value}}. Enter now!',
    notifSpinTitle: 'Daily Spin',
    notifSpinMessage: 'You won {{reward}} points!',
    notifTestimonialApprovedTitle: '✨ Your testimonial is now public!',
    notifTestimonialApprovedMessage: 'Your testimonial for {{raffle}} has been approved and is now visible on the winners page.',
    notifTestimonialRejectedTitle: 'Please rewrite your testimonial',
    notifTestimonialRejectedMessage: 'Your testimonial for {{raffle}} needs a small adjustment. Please rewrite it from your account.',
    notifTestimonialPendingTitle: '📝 New testimonial to validate',
    notifTestimonialPendingMessage: '{{firstName}} {{lastName}} submitted a testimonial for {{raffle}}.',
    videoUrl: 'Video URL (YouTube/Vimeo)',
    // New features
    dailySpin: 'Daily Spin',
    spinNow: 'Spin Now',
    spinning: 'Spinning...',
    spinRewardMsg: 'Come back tomorrow for another spin!',
    liveChat: 'Live Chat',
    liveChatDesc: 'We usually reply within minutes',
    chatWelcome: 'Hi! How can we help you today?',
    typeMessage: 'Type a message...',
    share: 'Share',
    analytics: 'Analytics',
    banners: 'Banners',
    manageBannersDesc: 'Manage promotional banners',
    newBanner: 'New Banner',
    userProfile: 'User Profile',
    personalInfo: 'Personal Information',
    totalSpent: 'Total Spent',
    referredBy: 'Referred by',
    referrals: 'Referrals',
    close: 'Close',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    addressPlaceholder1: '123 High Street',
    addressPlaceholder2: 'Flat 4, Building name...',
    county: 'County / Region',
    countryLabel: 'Country',
    changePassword: 'Change Password',
    confirmPassword: 'Confirm New Password',
    passwordUpdated: 'Password updated successfully',
    bothFieldsRequired: 'All fields are required',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordsMismatch: 'Passwords do not match',
    linkCopiedInstagram: 'Link copied! Paste it in your Instagram story or DM.',
    uploadImages: 'Upload Images',
    uploadImage: 'Upload',
    questionImage: 'Question Image',
    // Point rate & payment
    pointRateLabel: 'Point Rate',
    pointRateHelp: 'How many points equal £1? (e.g. 1 = 1pt/£1, 2 = 2pts/£1)',
    pointsPerPound: 'point(s) = £1',
    currentRate: 'Current rate',
    perEntry: 'per entry',
    payWithPoints: 'Pay with Points',
    payDirect: 'Pay Directly (£)',
    directPaymentInfo: 'Stripe payment integration coming soon.',
    stripeComingSoon: 'Payment integration coming soon!',
    payNow: 'Pay Now',
    // VIP
    vip: 'VIP',
    vipExclusive: 'VIP Exclusive',
    vipTitle: 'Unlock VIP Privileges',
    vipDesc: 'Join the VIP club for exclusive benefits, priority access to new draws, and monthly bonus points delivered straight to your account.',
    yourSubscription: 'Your Subscription',
    subscribe: 'Subscribe Now',
    ptsPerMonth: '£/month',
    month: 'month',
    year: 'year',
    vipBenefitsTitle: 'Why Go VIP?',
    vipBenefit1Title: 'Monthly Points',
    vipBenefit1Desc: 'Receive points every month, automatically.',
    vipBenefit2Title: 'Priority Access',
    vipBenefit2Desc: 'Be first to enter new exclusive draws.',
    vipBenefit3Title: 'Pack Bonuses',
    vipBenefit3Desc: 'Extra bonus percentage on all point packs.',
    vipBenefit4Title: 'VIP Status',
    vipBenefit4Desc: 'Exclusive VIP badge and recognition.',
    vipMonthlyName: 'VIP Monthly',
    vipAnnualName: 'VIP Annual',
    vipBenefitMonthly1: '200 points/month',
    vipBenefitAnnual1: '250 points/month',
    vipBenefitPriority: 'Priority access to new draws',
    vipBenefitExclusive: 'Exclusive VIP draws',
    vipBenefitBonus10: '10% bonus on point packs',
    vipBenefitBonus15: '15% bonus on point packs',
    vipBenefitBirthday: 'Birthday bonus',
    vipPlans: 'VIP Plans',
    manageVipDesc: 'Manage VIP subscription plans, pricing and benefits',
    addPlan: 'Add Plan',
    saveAll: 'Save All',
    planId: 'Plan ID',
    planName: 'Plan Name',
    pointsPerMonth: 'Points / Month',
    priceGbp: 'Price (£)',
    benefitsList: 'Benefits',
    addBenefit: 'Add',
    // Navigation menu flags
    navigationMenu: 'Navigation Menu',
    navCompetitions: 'Competitions link',
    navHowItWorks: 'How it Works link',
    navWinnersMenu: 'Winners link',
    navVip: 'VIP link',
    ticketPackages: 'Ticket Packages',
    addPackage: 'Add Package',
    qty: 'Qty',
    choosePackage: 'Choose a package',
    chanceToWin: 'chance of winning',
    discount: 'Discount',
    tickets: 'Tickets',
    // Points History
    pointsHistory: 'Credit History',
    totalEarned: 'Total Earned',
    totalSpentPts: 'Total Spent',
    currentBalanceShort: 'Balance',
    adminCredit: 'Admin Credit',
    adminDebit: 'Admin Debit',
    raffleEntry: 'Ticket Purchase',
    dailySpinBonus: 'Daily Spin',
    referralBonusTx: 'Referral Bonus',
    signupBonusTx: 'Welcome Bonus',
    shareBonusTx: 'Share Bonus',
    // Transaction descriptions (localised client-side)
    txDescSignupBonus: 'Welcome bonus',
    txDescEntry: 'Entry x{{qty}} — {{raffle}}',
    txDescReferralBonusCode: 'Referral bonus (code: {{code}})',
    txDescReferralBonusReferred: 'Referral bonus (referred: {{email}})',
    txDescSpinReward: 'Daily spin reward: +{{reward}} pts',
    txDescShareBonus: 'Share bonus',
    txDescAdminCredit: 'Admin credit',
    txDescAdminDebit: 'Admin debit',
    shareReferralInfo: 'Your referral link is included!',
    shareEarnInfo: 'Your referral code is included. You earn points when someone registers via your link.',
    linkCopied: 'Link copied to clipboard!',
    referralBonusHelp: 'Points awarded to both the referrer and the new user when someone registers via a referral link or share.',
    // Spin admin
    spinWheel: 'Spin Wheel',
    manageSpinDesc: 'Configure prizes, weights and frequency',
    frequency: 'Frequency',
    freqDaily: 'Once per day',
    freq12h: 'Every 12 hours',
    freq2days: 'Every 2 days',
    freq3days: 'Every 3 days',
    freqWeekly: 'Once per week',
    freqBiweekly: 'Every 2 weeks',
    freqMonthly: 'Once per month',
    totalSegments: 'Total segments',
    totalWeightLabel: 'Total weight',
    prizes: 'Prizes',
    addPrize: 'Add Prize',
    weight: 'Weight',
    probability: 'Probability',
    noSegments: 'No segments configured. Add prizes to enable the wheel.',
    newsletter: 'Newsletter',
    manageNewsletterDesc: 'Create and send newsletters to your users',
    newNewsletter: 'New Newsletter',
    noNewsletters: 'No newsletters yet. Create your first one!',
    emailConfig: 'Email Config',
    fromEmail: 'Sender Email',
    sendgridHelp: 'Get your API key from sendgrid.com. Without it, emails are queued but not sent.',
    autoNotifications: 'Auto Notifications',
    notifyNewRaffle: 'New raffle notification',
    notifyNewRaffleDesc: 'Automatically email all users when a new draw is created',
    noSendgridWarning: 'SendGrid API key not configured. Emails will be queued but not sent. Add your key to enable sending from newsletter@winluxor.com',
    subject: 'Subject',
    contentHtml: 'Content (HTML supported)',
    templates: 'Templates',
    preview: 'Preview',
    // Specifications
    specifications: 'Specifications',
    maxWinners: 'Maximum Winners',
    maximumEntries: 'Maximum Entries',
    specBrand: 'Brand',
    specModel: 'Model',
    specRefNumber: 'Reference Number',
    specMovement: 'Movement',
    specYear: 'Year',
    specCaliber: 'Caliber',
    specGlass: 'Glass',
    specBezelMaterial: 'Bezel Material',
    specBraceletMaterial: 'Bracelet Material',
    specPapers: 'Papers & Box',
    specReference: 'Reference',
    specMaterial: 'Material',
    specColor: 'Color',
    specSize: 'Size',
    specHardware: 'Hardware',
    specType: 'Type (Ring, Necklace...)',
    specStones: 'Stones',
    specCarat: 'Carat',
    specCertification: 'Certification',
    specItemsIncluded: 'Items Included',
    specStorage: 'Storage',
    specWarranty: 'Warranty',
    specDestination: 'Destination',
    specDuration: 'Duration',
    specHotel: 'Hotel / Resort',
    specStars: 'Stars',
    specIncluded: 'Included (flights, meals...)',
    specDepartureFrom: 'Departure From',
    specValidUntil: 'Valid Until',
    specEngine: 'Engine',
    specMileage: 'Mileage',
    specTransmission: 'Transmission',
    specDetails: 'Details',
  },
  fr: {
    home: 'Accueil',
    draws: 'Concours',
    howItWorks: 'Comment ça marche',
    signIn: 'Se connecter',
    joinNow: 'Rejoindre',
    forgotPassword: 'Mot de passe oublié ?',
    randomDrawCertLabel: 'Transparence absolue',
    randomDrawCertTitle: 'Tirages 100% aléatoires & certifiés',
    randomDrawCertDesc: 'Chaque tirage est effectué via un système aléatoire certifié et indépendant — le résultat est public et vérifiable. Vous avez la garantie d\'une équité totale.',
    randomDrawCertCaption: 'Certifié par randomdraws.com — vérifiable en ligne',
    moreOptions: 'Plus d\'options (crédit, code promo, détails)',
    totalToPay: 'Total à payer',
    answerRequired: 'Question obligatoire',
    payByCard: 'Payer par carte',
    useMyCredit: 'Utiliser mon crédit',
    balance: 'Solde',
    boughtLabel: 'achetés',
    remainingLabel: 'reste',
    limitReached: 'limite atteinte',
    ticketsLowercase: 'tickets',
    forgotPasswordTitle: 'Mot de passe oublié ?',
    forgotPasswordSubtitle: 'Entrez votre email — nous vous enverrons un lien sécurisé pour créer un nouveau mot de passe.',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    sending: 'Envoi…',
    emailSentTitle: 'Email envoyé !',
    forgotPasswordSent: 'Si cette adresse est associée à un compte, vous recevrez un email avec un lien pour réinitialiser votre mot de passe.',
    checkSpamTitle: 'Vérifiez vos spams',
    checkSpam: 'L\'email peut prendre 1-2 minutes pour arriver. Si vous ne le trouvez pas dans votre boîte de réception, vérifiez vos spams ou indésirables.',
    linkValidFor: 'Le lien sera valide pendant 1 heure.',
    backToLogin: 'Retour à la connexion',
    rememberPassword: 'Vous vous souvenez ?',
    emailRequired: 'Veuillez entrer votre adresse email',
    errorOccurred: 'Une erreur est survenue',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    myAccount: 'Mon compte',
    admin: 'Admin',
    signOut: 'Déconnexion',
    adminPanel: 'Panel Admin',
    heroBadge: 'La référence des concours de luxe au UK',
    heroTitle1: 'Gagnez des',
    heroTitle2: 'prix',
    heroTitle3: 'extraordinaires',
    heroDesc: 'Participez à des concours de luxe pour une fraction du prix. Rolex, Hermès, Apple — votre prix de rêve est à portée de main.',
    viewActiveDraws: 'Voir les concours',
    featuredDraw: 'Concours vedette',
    worth: 'Valeur',
    howItWorksTitle: 'Comment ça marche',
    howItWorksSubtitle: 'Trois étapes simples pour gagner des prix de luxe',
    step1Title: 'Créez votre compte',
    step1Desc: 'Inscrivez-vous en quelques secondes avec votre email. Rapide, simple, sécurisé.',
    step2Title: 'Rechargez votre crédit',
    step2Desc: 'Ajoutez du crédit à votre compte en £ — obtenez jusqu\u2019à +10% de bonus sur les grosses recharges. Ou passez cette étape et payez vos tickets directement par carte.',
    step3Title: 'Choisissez votre tirage',
    step3Desc: 'Parcourez nos tirages exclusifs et choisissez votre prix de rêve.',
    step4Title: 'Répondez & Participez',
    step4Desc: 'Répondez à une question simple, puis payez avec votre crédit OU directement par carte.',
    step5Title: 'Gagnez votre rêve',
    step5Desc: 'Les gagnants sont tirés au sort de manière équitable et transparente. Ce pourrait être vous !',
    securePayments: 'Paiements sécurisés',
    sslEncrypted: 'Chiffré SSL',
    ukCompliant: 'Conforme UK',
    fullyRegulated: 'Entièrement régulé',
    realWinners: 'Vrais gagnants',
    verifiedDraws: 'Tirages vérifiés',
    instantCredits: 'Crédits instantanés',
    pointsAddedInstantly: 'Points ajoutés instantanément',
    activeDraws: 'Tirages actifs',
    dontMiss: 'Ne manquez pas votre chance de gagner',
    drawsLive: 'tirages en cours',
    allLiveDraws: 'Tous les concours en direct',
    unavailable: 'Indisponible',
    viewDraw: 'Voir le concours',
    getYourTicket: 'Obtenir mon ticket',
    orUntilSoldOut: 'ou jusqu\u2019à épuisement des tickets',
    value: 'Valeur',
    sold: 'vendus',
    left: 'restants',
    entry: 'entrée',
    enterDraw: 'Participer',
    hot: 'POPULAIRE',
    endingSoon: 'BIENTÔT FINI',
    endsToday: "Se termine aujourd'hui",
    liveCountdown: 'Se termine dans',
    days: 'jours',
    hrs: 'hrs',
    min: 'min',
    sec: 'sec',
    ageGate18Plus: 'Vérification 18+',
    liveCompetitions: 'Compétitions en direct',
    process: 'Processus',
    topUp: 'Recharger',
    hallOfWinners: 'Salle des gagnants',
    quickActions: 'Actions rapides',
    welcomeBack: 'Bon retour',
    myAccount: 'Mon compte',
    wallet: 'Portefeuille',
    exclusivePerks: 'Avantages exclusifs',
    copiedToClipboard: 'Copié !',
    whatsappPrompt: 'Une question ? Contactez-nous !',
    whatsappEnableLabel: 'Activer le badge WhatsApp',
    whatsappEnableHelp: 'Afficher un bouton WhatsApp flottant à gauche du site',
    whatsappNumberLabel: 'Numéro WhatsApp (avec indicatif pays)',
    whatsappNumberHelp: 'Format international. Les espaces et tirets sont supprimés automatiquement.',
    whatsappMessageLabel: 'Message pré-rempli (optionnel)',
    saving: 'Enregistrement...',
    socialMediaLinks: 'Liens réseaux sociaux (Footer)',
    socialMediaHelp: 'Configurer les URLs et la visibilité des icônes de réseaux sociaux dans le footer',
    socialLinksSaved: 'Liens enregistrés',
    brandingTitle: 'Identité visuelle du site',
    brandingHelp: 'Personnalisez logos, favicon et titre de l\'onglet navigateur. Les changements sont appliqués instantanément.',
    brandingTitleLabel: 'Titre de l\'onglet navigateur',
    brandingTitleHelp: 'Affiché dans l\'onglet du navigateur à côté du favicon. Laissez vide pour la valeur par défaut.',
    brandingMainLogo: 'Logo principal (header)',
    brandingSmallLogo: 'Petit logo (en scrollant)',
    brandingFavicon: 'Favicon (onglet navigateur)',
    brandingSaved: 'Identité enregistrée & appliquée',
    upload: 'Téléverser',
    uploading: 'Téléversement...',
    uploadSuccess: 'Image téléversée',
    fileTooBig: 'Fichier trop volumineux (max 5MB)',
    resetToDefault: 'Réinitialiser',
    saveAndApply: 'Enregistrer & Appliquer',
    backups: 'Sauvegardes',
    legalPages: 'Pages Légales',
    siteTexts: 'Textes du site',
    payments: 'Paiements',
    salesDashboard: 'Ventes',
    whatsappContacts: 'Contacts WhatsApp',
    chooseTickets: 'Choisissez vos tickets',
    orChooseAmount: 'Ou choisissez :',
    seeAllPacks: 'Voir tous les packs disponibles',
    availablePacks: 'Packs disponibles',
    discountApplied: 'Réduction appliquée !',
    ticket: 'ticket',
    paymentMethod: 'Paiement',
    cost: 'Coût',
    paidWithCard: 'Carte',
    paidWithPoints: 'Crédit',
    stripePack: '💳 Achat Stripe',
    vipSubscription: '👑 Abonnement VIP',
    myPayments: 'Mes paiements',
    totalPaid: 'Total payé',
    ticketPurchases: 'Achats tickets',
    otherPurchases: 'Packs & VIP',
    noPayments: 'Aucun paiement par carte',
    noPaymentsHint: 'Vos paiements par carte apparaîtront ici.',
    pointPack: 'Crédit',
    vipSubscription2: 'Abonnement VIP',
    raffleTickets: 'Tickets tirage',
    paid: 'Payé',
    pending: 'En attente',
    status: 'Statut',
    paymentsHint: 'Tous les paiements par carte (packs de points, VIP, tickets directs) sont listés ici.',
    mySubscription: 'Mon abonnement',
    activeSubscription: 'Abonnement Actif',
    pointsPerMonth: 'Points / mois',
    perYear: 'Par an',
    perMonth2: 'Par mois',
    renewsOn: 'Renouvellement',
    yourBenefits: 'Vos avantages',
    memberSince: 'Membre depuis',
    changePlan: 'Changer de plan',
    cancelSubscription: 'Annuler l\u2019abonnement',
    cancelHint: 'Si vous annulez, vous gardez vos avantages VIP jusqu\u2019à la fin de la période payée.',
    noActiveSubscription: 'Aucun abonnement actif',
    vipPromo: 'Devenez VIP pour profiter de points mensuels, accès prioritaire et avantages exclusifs.',
    discoverVip: 'Découvrir les abonnements VIP',
    confirmCancelSubscription: 'Êtes-vous sûr de vouloir annuler votre abonnement VIP ? Vous garderez vos avantages jusqu\u2019à la fin de la période en cours.',
    subscriptionCancelled: 'Abonnement annulé',
    active: 'Actif',
    currentPlan: 'Plan actuel',
    alreadyActive: 'Déjà actif',
    cancelToSwitch: 'Annuler pour changer',
    cancelFirstHint: 'Annulez d\u2019abord votre abonnement actuel depuis votre compte avant de souscrire à un autre plan.',
    loginToParticipate: 'Se connecter pour participer',
    securePaymentInfo: '🔒 Paiement sécurisé par Stripe',
    // ── Participation express / sans mot de passe ──
    participate: 'Participer',
    allUsersTab: 'Tous',
    expStepQuestion: 'Petite question',
    expStepInfo: 'Vos coordonnées',
    expStepPay: 'Paiement',
    expAnswerQuestion: 'Répondez pour continuer',
    expContinue: 'Continuer',
    expBack: 'Retour',
    expWrongAnswer: 'Mauvaise réponse, réessayez.',
    expSelectAnswer: 'Veuillez sélectionner une réponse.',
    expAlreadyClient: 'Déjà client ? Se connecter',
    expContinueAsGuest: 'Continuer sans me connecter',
    expSignInTitle: 'Connectez-vous à votre espace',
    expSignInDesc: 'Entrez votre email, nous vous envoyons un code à 6 chiffres.',
    expSendCode: 'Recevoir mon code',
    expCodeSent: 'Code envoyé ! Vérifiez votre boîte mail.',
    expEnterCode: 'Saisissez le code à 6 chiffres',
    expVerify: 'Vérifier & se connecter',
    expResendCode: 'Renvoyer un code',
    expFirstName: 'Prénom',
    expLastName: 'Nom',
    expEmail: 'Email',
    expPhone: 'Téléphone',
    expCountry: 'Pays',
    expPostcode: 'Code postal',
    expAddress: 'Adresse',
    expCity: 'Ville',
    expSecureBanner: '🔒 Vos informations sont sécurisées et servent uniquement à la livraison de votre lot.',
    expFillRequired: 'Veuillez remplir tous les champs obligatoires.',
    expPayByCard: '💳 Payer par carte',
    expContinueToPay: 'Continuer vers le paiement',
    expWelcomeBack: 'Content de vous revoir',
    expNoPasswordHint: 'Aucun mot de passe — vous restez connecté sur cet appareil.',
    useMyCredit: 'Utiliser mon crédit',
    confirmParticipation: 'Confirmer ma participation',
    participationConfirmed: 'Participation enregistrée ! 🎉',
    joinTitle: 'Rejoindre WINLUXOR',
    joinDesc: 'Entrez votre email — vous recevrez un code à 6 chiffres. Aucun mot de passe.',
    updateProfileTitle: 'Bienvenue ! 🎉',
    updateProfileDesc: 'Complétez votre profil maintenant (facultatif) — ça accélère vos prochains achats.',
    saveProfile: 'Enregistrer mon profil',
    skipForNow: 'Plus tard',
    profileSaved: 'Profil enregistré ✓',
    orDivider: 'ou',
    googleContinue: 'Continuer avec Google',
    googleComingSoon: 'Connexion Google bientôt disponible — en cours de configuration.',
    comingSoon: 'Bientôt',
    comingSoon: 'Bientôt disponible',
    comingSoonHint: 'Restez connecté ! Ce tirage sera bientôt disponible.',
    comingSoonDetailHint: 'Ce tirage sera bientôt ouvert à la participation. Revenez prochainement !',
    raffleStatusLabel: 'Type de tirage',
    raffleStatusHelp: 'Choisissez si ce tirage est actif ou seulement annoncé pour plus tard.',
    statusActive: 'Actif',
    statusActiveHelp: 'Tickets en vente. Prix + décompte affichés.',
    statusComingSoon: 'Bientôt',
    statusComingSoonHelp: 'Annonce uniquement. Pas de prix, pas de date, achat bloqué.',
    creditReceived: 'Crédit reçu',
    youPay: 'Vous payez',
    payWithCredit: 'Payer avec mon crédit',
    insufficientCredit: 'Crédit insuffisant',
    ticketPrice: 'Prix ticket',
    ticketsMax: 'Tickets max',
    totalTickets: 'Tickets max',
    totalTicketsAvailable: 'Total tickets disponibles',
    packEnabled: 'Pack activé',
    packDisabled: 'Pack désactivé',
    member: 'Membre',
    memberLevelStandard: 'Standard',
    memberLevelBronze: 'Bronze',
    memberLevelSilver: 'Argent',
    memberLevelGold: 'Or',
    backupTitle: 'Sauvegardes',
    backupSubtitle: 'Migration & Restauration',
    backupHelp: 'Téléchargez des snapshots complets du site (design + données clients) et réimportez-les sur n\'importe quel serveur. Tout ce qu\'il vous faut pour migrer ou récupérer en cas de problème.',
    backupDesignTitle: 'Sauvegarde Design',
    backupDesignItem1: 'Paramètres et identité visuelle (logos, couleurs, titres)',
    backupDesignItem2: 'Structure des tirages (titres, descriptions, packages)',
    backupDesignItem3: 'Packs de points, plans VIP, codes promo',
    backupDesignItem4: 'Bannières, newsletters, pages CMS',
    backupDesignItem5: 'Toutes les images téléversées (logos, photos de raffles)',
    backupClientsTitle: 'Sauvegarde Données Clients',
    backupClientsItem1: 'Tous les comptes utilisateurs (y compris admin)',
    backupClientsItem2: 'Solde de points, transactions, historique',
    backupClientsItem3: 'Participations aux tirages',
    backupClientsItem4: 'Notifications, gains, abonnements',
    backupClientsItem5: 'Messages chat, file email, parrainages',
    downloadDesignZip: 'Télécharger Design ZIP',
    downloadClientsJson: 'Télécharger Clients JSON',
    backupDownloaded: 'Sauvegarde téléchargée',
    backupDownloadFailed: 'Échec du téléchargement',
    preparing: 'Préparation...',
    restoreZone: 'Zone de danger — Restauration',
    restoreHelp: 'Déposez un fichier de sauvegarde ci-dessous. Le système détecte automatiquement le type (ZIP design ou JSON clients).',
    dropOrClick: 'Déposez un fichier ici, ou cliquez pour parcourir',
    supportedFormats: 'Formats acceptés : .zip (design) ou .json (clients) — jusqu\'à 1 Go',
    removeFile: 'Retirer',
    modeReplace: 'Remplacer (recommandé)',
    modeReplaceHelp: 'Efface les collections existantes et écrase. Idéal pour une migration complète.',
    modeMerge: 'Fusionner (garder existant)',
    modeMergeHelp: 'Ajoute les données de sauvegarde sans supprimer les actuelles. Ignore les doublons par ID.',
    confirmRestoreLabel: 'Tapez RESTORE pour confirmer',
    typeRestoreToConfirm: 'Tapez RESTORE pour confirmer',
    restoring: 'Restauration...',
    restoreNow: 'Restaurer maintenant',
    restoreSuccess: 'Restauration terminée',
    restoreSuccessTitle: 'Restauration terminée',
    uploadsRestored: 'Fichiers restaurés',
    status: 'Statut',
    blocked: 'Bloqué',
    active: 'Actif',
    block: 'Bloquer',
    unblock: 'Débloquer',
    delete: 'Supprimer',
    view: 'Voir',
    confirmDelete: 'Supprimer l\'utilisateur ?',
    confirmBlock: 'Bloquer l\'utilisateur ?',
    confirmUnblock: 'Débloquer l\'utilisateur ?',
    deleteWarning: 'Cette action est définitive et irréversible.',
    deleteWarningDetail: 'Le compte, toutes les participations, transactions et notifications de cet utilisateur seront supprimés.',
    blockExplain: 'L\'utilisateur ne pourra plus se connecter tant que vous ne le débloquerez pas. Ses données sont conservées.',
    unblockExplain: 'L\'utilisateur pourra se reconnecter immédiatement.',
    typeDeleteToConfirm: 'Tapez DELETE pour confirmer',
    deletePermanently: 'Supprimer définitivement',
    userBlocked: 'Utilisateur bloqué',
    userUnblocked: 'Utilisateur débloqué',
    userDeleted: 'Utilisateur supprimé',
    processing: 'Traitement...',
    designate: 'Désigner',
    designateWinner: 'Désigner le gagnant',
    designateExplain: 'Sélectionnez le gagnant dans la liste des participants. Une fois confirmé, l\'utilisateur recevra une notification dans son espace + un email magnifique. Le tirage sera marqué comme terminé.',
    searchParticipants: 'Rechercher par nom ou email...',
    loadingParticipants: 'Chargement des participants...',
    noParticipantsYet: 'Aucun participant pour ce tirage pour le moment.',
    confirmWinner: 'Confirmer le gagnant & notifier',
    winners: 'Gagnants',
    winnersAdminHelp: 'Gérez tous les gagnants désignés. Publiez-les une fois le prix remis et les photos prises.',
    publishWinner: 'Publier (avec photos)',
    publishWinnerDialog: 'Publier le gagnant avec photos',
    photosLabel: 'Photos de la remise',
    photosHelp: 'Téléversez 1 à 10 photos du gagnant avec son prix.',
    testimonialLabel: 'Témoignage / message (optionnel)',
    publishNow: 'Publier maintenant',
    publishing: 'Publication...',
    winnerPublished: '✨ Gagnant publié sur /winners',
    atLeastOnePhoto: 'Téléversez au moins une photo',
    uploadPhotos: 'Téléverser des photos',
    won: 'A gagné',
    designatedAt: 'Désigné',
    publishedAt: 'Publié',
    noPendingWinners: 'Aucun gagnant en attente',
    noPendingWinnersHelp: 'Désignez d\'abord un gagnant depuis la page Tirages.',
    noPublishedWinners: 'Aucun gagnant publié pour le moment',
    soldOut: 'Épuisé',
    loginTitle: 'Connexion',
    loginSubtitle: "Utilisez l'email et le mot de passe créés sur WINLUXOR.",
    forgotShort: 'Oublié ?',
    signingIn: 'Connexion…',
    notRegisteredYet: 'Pas encore inscrit ?',
    createAccount: 'Créer un compte',
    createAccountSub: '30 secondes — gratuit',
    alreadyRegistered: 'Déjà inscrit ?',
    signIn: 'Me connecter',
    welcomeWinluxor: 'Bienvenue sur WINLUXOR',
    createAccountIntro: 'Créez votre compte gratuit pour participer aux tirages.',
    createMyAccount30s: 'Créer mon compte en 30 secondes',
    haveAccountLogin: "J'ai déjà un compte → me connecter",
    verifyTicketTitle: 'Vérifiez votre numéro de ticket',
    verifyTicketIntro: "Tous nos tirages sont effectués via un service de tirage aléatoire indépendant pour garantir une équité totale. Cliquez ci-dessous, saisissez votre numéro de ticket et vérifiez qu'il fait partie du tirage officiel.",
    verifyTicketCta: 'Vérifier mon ticket',
    soldOutBig: 'Tous les tickets vendus',
    soldOutDetailHelp: 'Plus de tickets disponibles. Le tirage aura lieu à la date prévue.',
    soldOutAdvancedDrawPending: 'Tirage avancé suite au sold out. Date à venir prochainement — revenez bientôt !',
    soldOutAdvancedDrawWithDate: 'Tirage avancé ! Découvrez la nouvelle date ci-dessous.',
    advancedDrawLabel: 'Tirage avancé',
    advancedDrawComingSoon: 'Date à venir prochainement',
    advancedDrawComingSoonHelp: 'Repassez bientôt pour découvrir la nouvelle date du tirage.',
    advancedDrawDateLabel: 'Date du tirage avancé',
    advancedDrawDateHelp: 'Tirage avancé suite à un sold out anticipé. Laissez vide tant que vous ne connaissez pas la date : les joueurs verront « Date à venir prochainement ». Une fois renseignée, un compte à rebours s\'affichera.',
    advancedDrawDateMissing: 'Aucune date renseignée — l\'UI publique affiche « Tirage avancé · Date à venir prochainement ».',
    advancedDrawDateSet: 'Compte à rebours actif jusqu\'à cette date sur la fiche publique.',
    clearDate: 'Effacer la date',
    // Per-raffle email actions (admin)
    resendLaunchEmail: 'Renvoyer l\'email de lancement à tous les clients',
    sendUrgencyEmail: 'Envoyer email urgence (tickets restants)',
    resendSoldOutEmail: 'Renvoyer email « Sold out — tirage avancé » aux participants',
    resendDrawDateEmail: 'Renvoyer email « Date du tirage annoncée » aux participants',
    confirmResendLaunch: 'Renvoyer l\'email de lancement de ce tirage à TOUS les clients ?',
    confirmSendUrgency: 'Envoyer un email URGENCE avec photo + gros titre « Plus que X tickets disponibles » ?',
    confirmResendSoldOut: 'Renvoyer aux PARTICIPANTS le mail « Tirage sold out — tirage avancé, date à venir » ?',
    confirmResendDrawDate: 'Renvoyer aux PARTICIPANTS le mail « Date du tirage annoncée » avec compte à rebours ?',
    noDrawDateSet: 'Aucune date de tirage configurée. Renseignez-la d\'abord.',
    noTicketsLeft: 'Aucun ticket restant. Utilisez plutôt « Renvoyer email lancement ».',
    ticketsLeftLabel: 'tickets restants',
    emailQueuedSuffix: 'email(s) en file d\'envoi',
    participantsEmailedSuffix: 'participant(s) notifiés',
    marketingOptions: 'Marketing & Statut',
    featuredHomeLabel: 'À la Une (Hero accueil)',
    featuredHomeHelp: 'Un seul tirage peut être à la une. Activer celui-ci désactivera les autres.',
    forceSoldOutLabel: 'Forcer Sold Out',
    forceSoldOutHelp: 'Marquer manuellement comme épuisé (arrête les nouveaux achats). Le compte à rebours du tirage reste visible.',
    displayedSoldTicketsLabel: 'Tickets vendus affichés (override)',
    displayedSoldTicketsHelp: 'Optionnel. Si rempli, le site public affichera ce nombre au lieu du vrai (boost psychologique). Le vrai compteur est préservé.',
    leaveEmptyForReal: 'Vide pour afficher le vrai compteur',
    drawn: 'Tiré',
    disabled: 'Désactivé',
    winnerDrawn: 'Gagnant tiré',
    ended: 'Terminé',
    markRead: 'Marquer lu',
    winnerNotifTitle: 'Félicitations ! Vous avez gagné',
    winnerNotifMessage: 'Vous êtes le gagnant de {{raffle}} — d\'une valeur de £{{value}}. Notre équipe vous contactera sous 48 heures.',
    // Common toast / confirm
    toastUpdated: 'Mis à jour',
    toastCreated: 'Créé',
    toastDeleted: 'Supprimé',
    toastSaved: 'Enregistré',
    toastFailed: 'Action échouée',
    toastUploadFailed: 'Échec du téléversement',
    confirmDeleteShort: 'Supprimer ?',
    confirmDeleteRaffle: 'Supprimer ce tirage ?',
    confirmDeleteUser: 'Supprimer cet utilisateur ?',
    confirmDeleteWinner: 'Supprimer ce gagnant ? Le tirage sera ré-ouvert pour un nouveau tirage.',
    confirmUnpublishWinner: 'Dépublier ce gagnant (retour en attente) ?',
    confirmAutoDraw: 'Tirer aléatoirement un gagnant ? Cette action est irréversible.',
    confirmSendNewsletter: 'Envoyer cette newsletter à TOUS les utilisateurs ?',
    raffleUpdated: 'Tirage mis à jour',
    raffleUpdatedEmailSent: 'Tirage mis à jour — email envoyé aux participants',
    notifyParticipantsTitle: 'Prévenir les participants ?',
    notifyParticipantsDesc: 'Cette modification (date du tirage / sold out) peut être annoncée par email à tous les participants. Voulez-vous envoyer l\'email ?',
    saveWithoutEmail: 'Valider sans envoyer d\'email',
    saveAndSendEmail: 'Valider et envoyer l\'email',
    relanceEmail: 'Email de relance',
    relanceEmailTitle: 'Email de relance',
    relanceEmailDesc: 'Combien de tickets restants voulez-vous afficher dans le mail ? Vous verrez ensuite un aperçu exact avant l\'envoi.',
    ticketsLeftToDisplay: 'Tickets restants affichés dans le mail',
    realTicketsLeft: 'Réellement restants',
    seeEmailPreview: 'Voir l\'aperçu du mail',
    invalidTicketCount: 'Nombre invalide',
    raffleCreated: 'Tirage créé',
    questionImageUploaded: 'Image de question téléversée',
    imagesUploaded: 'image(s) téléversée(s)',
    enterImageUrl: 'Entrez l\'URL de l\'image :',
    featuredRemoved: 'Retiré de la une',
    featuredAdded: '⭐ Mis à la une',
    spinSaved: 'Roue de la fortune enregistrée !',
    vipPlansSaved: 'Plans VIP enregistrés',
    enterValidAmount: 'Entrez un montant valide',
    bothFieldsRequired: 'Les deux champs sont requis',
    passwordUpdated: 'Mot de passe mis à jour',
    winnerUnpublished: 'Gagnant dépublié',
    winnerDeletedReopen: 'Supprimé, tirage ré-ouvert',
    newsletterCreated: 'Newsletter créée',
    subjectRequired: 'Le sujet est requis',
    emailSettingsSaved: 'Paramètres email enregistrés',
    photoUploaded: 'photo(s) téléversée(s)',
    designateWinnerToast: '🏆 Gagnant désigné ! Utilisateur notifié par email + in-app.',
    drawSuccess: '🏆 Gagnant tiré',
    designateExplainerTitle: 'Choisissez le gagnant',
    drawScheduledIn: 'Tirage prévu dans',
    exportTickets: 'Exporter les tickets CSV',
    exportSuccess: 'Tickets exportés',
    closeRaffleNow: 'Fermer le tirage',
    confirmCloseRaffle: 'Fermer ce tirage maintenant ? La vente sera arrêtée et vous pourrez tirer le gagnant.',
    raffleClosedToast: 'Tirage fermé (vente arrêtée)',
    public: 'Public',
    hidden: 'MASQUÉ',
    hide: 'Cacher',
    hideFromPublic: 'Masquer du public',
    hideRaffle: 'Masquer (mode test)',
    showRaffle: 'Rendre visible',
    raffleNowHidden: '🙈 Tirage masqué (admins seulement)',
    raffleNowVisible: '✅ Tirage visible publiquement',
    defaultPhotos: 'Photos par défaut',
    editHandoverPhotos: 'Modifier photos / message',
    winnerUpdated: '✨ Gagnant mis à jour',
    addManualWinner: 'Ajouter un gagnant',
    manualWinnerHelp: 'Pour un gagnant hors site (réseaux sociaux, autres lots). Tous les champs sont optionnels.',
    winnerName: 'Nom du gagnant',
    prizeWon: 'Lot gagné',
    winningTicket: 'N° de ticket',
    addWinner: 'Ajouter le gagnant',
    winnerCreated: '🏆 Gagnant ajouté',
    allWinners: 'Tous les gagnants',
    noWinnersYet: 'Aucun gagnant pour le moment',
    noHiddenWinners: 'Aucun gagnant caché',
    limitedBadge: '🔥 Limité',
    luckyOnesBadge: 'Chanceux',
    maxPerUserField: 'Tickets max par joueur',
    maxPerUserHelp: 'Définissez un plafond strict par utilisateur sur ce tirage. Laissez vide ou 0 pour illimité.',
    unlimited: '0 = illimité',
    maxPerUserLabel: 'Tickets max par joueur',
    ticketsLowercase: 'tickets',
    maxPerUserSuffix: 'maximum sur ce tirage',
    youHave: 'Vous avez',
    youCanStillBuy: 'Vous pouvez encore en acheter',
    limitReached: 'Limite atteinte.',
    youCanBuyUpTo: 'Vous pouvez acheter jusqu\'à',
    myTicketsTitle: 'Vos tickets',
    yourTicketNumbers: 'Vos numéros de ticket',
    ticketsTip: 'Chaque numéro est unique. Le ticket gagnant sera tiré au sort parmi tous les tickets à la date prévue.',
    ticketsPlural: 'tickets',
    clickToSeeTickets: 'Cliquez sur une ligne pour voir vos numéros de ticket',
    testimonialDialogTitle: 'Partagez votre expérience !',
    testimonialDialogDesc: 'Racontez aux futurs gagnants ce que ça fait — votre témoignage sera affiché (après validation admin) sur la page des gagnants.',
    testimonialLabel2: 'Votre témoignage',
    testimonialPlaceholder: "ex: « Je n'aurais jamais cru gagner — c'est un rêve ! Merci WINLUXOR ! »",
    testimonialHint: 'Min 5, max 1000 caractères. Sera relu par notre équipe avant publication.',
    testimonialTooShort: 'Écrivez au moins 5 caractères',
    testimonialSubmitted: '✨ Envoyé en relecture !',
    testimonialThanks: 'Merci !',
    testimonialThanksDesc: "Votre témoignage a été envoyé à notre équipe pour relecture. Il apparaîtra sur la page Gagnants publique une fois approuvé.",
    submitTestimonial: 'Envoyer',
    submitting: 'Envoi...',
    later: 'Plus tard',
    testimonialPending: 'Témoignage en attente de relecture',
    reviewTestimonial: 'Relire & approuver',
    reviewTestimonialTitle: 'Relire le témoignage',
    reviewTestimonialHelp: 'Vous pouvez modifier le texte ci-dessous pour corriger les fautes avant d\'approuver. L\'utilisateur sera notifié une fois approuvé.',
    originalText: 'Texte original soumis par l\'utilisateur',
    finalText: 'Texte final (éditable)',
    approve: 'Approuver & Publier',
    reject: 'Rejeter',
    testiApproved: '✓ Témoignage approuvé',
    testiRejected: 'Témoignage rejeté (utilisateur notifié)',
    byTicketCode: 'Par code ticket gagnant',
    byTicketCodeHelp: 'Collez le code retourné par votre système de tirage',
    manualSelection: 'Sélection manuelle',
    manualSelectionHelp: 'Choisir un utilisateur et un ticket spécifique',
    winningTicketCode: 'Code du ticket gagnant',
    winningTicketCodeHelp: 'Entrez le code retourné par votre système de tirage externe. Le système trouvera automatiquement l\'utilisateur qui possède ce ticket.',
    selectTheirTicket: 'Sélectionner son ticket gagnant',
    selectUser: 'Sélectionnez un participant',
    codeRequired: 'Entrez un code de ticket gagnant',
    winningTicket: 'Ticket gagnant',
    youAreTheWinner: 'Vous êtes le gagnant !',
    ticketLabel: 'Ticket',
    testimonialAwaiting: 'Témoignage à venir...',
    swipeToSee: 'Glissez pour voir plus',
    useTemplate: 'Utiliser un template',
    availableTemplates: 'Templates disponibles',
    saveAsTemplate: 'Sauver comme template',
    saveAsTemplateHelp: 'Sauvegarder les packages actuels comme template réutilisable',
    templateApplied: 'Template appliqué',
    templateSaved: 'Template enregistré',
    templateNamePrompt: 'Nom du template (ex: "Standard 5/20/50/100"):',
    confirmDeleteTemplate: 'Supprimer ce template ?',
    noPackagesToSave: 'Aucun package à sauvegarder',
    noPackagesYet: 'Aucun package pour le moment. Ajoutez-en un manuellement ou utilisez un template.',
    option1: 'Option 1',
    option2: 'Option 2',
    buyPointsOption: 'Recharger crédit',
    buyPointsOptionDesc: 'Ajoutez du crédit à votre compte et obtenez jusqu\'à +15% de bonus sur les grosses recharges.',
    buyPointsBonus: 'Jusqu\'à +30% de points bonus sur les gros packs !',
    fast: 'Rapide',
    seePacks: 'Voir les packs',
    buyTicketDirectOption: 'Acheter un ticket directement',
    buyTicketDirectDesc: 'Pas besoin de recharger — choisissez un tirage et achetez vos tickets en un clic.',
    seeDraws: 'Voir les tirages',
    maxParticipants: 'Participants max',
    maxParticipantsHelp: 'Participations limitées — fortes chances de gagner',
    maxWinnersLabel: 'Gagnants max',
    maxWinnersHelp: 'Gagnant(s) sélectionné(s) par tirage aléatoire',
    urgencyTitle: 'Les tirages de ce soir se terminent bientôt',
    urgencyDesc: 'Sécurisez vos participations avant qu\'il ne soit trop tard.',
    enterNow: 'Participer maintenant',
    recentWinners: 'Gagnants récents',
    realPeopleRealPrizes: 'De vraies personnes, de vrais prix',
    prizesWonLabel: 'Lots remportés',
    welcomeOfferShort: 'bienvenue',
    welcomeOfferApplied: 'Offre de bienvenue appliquée',
    welcomeBannerText: '🎁 £{amount} offerts sur ta 1ʳᵉ participation — profites-en',
    welcomeOfferTitle: 'Offre de bienvenue',
    welcomeOfferHelp: 'Remise auto sur la 1ʳᵉ participation (1 fois par compte).',
    welcomeOfferAmount: 'Montant (£)',
    welcomeOfferMin: 'Achat min (£)',
    verifiedWinner: 'Gagnant vérifié',
    won: 'A gagné',
    pointPacks: 'Recharger crédit',
    buyPointsDesc: 'Rechargez votre crédit et participez à vos tirages préférés',
    mostPopular: 'Le plus populaire',
    pts: '£',
    bonus: 'bonus',
    buyPoints: 'Recharger',
    faqTitle: 'Questions fréquentes',
    faq1q: 'Comment fonctionne WINLUXOR ?',
    faq1a: 'Achetez des points, choisissez un tirage et participez pour avoir une chance de gagner des prix de luxe. Chaque participation vous donne une chance équitable. Les gagnants sont sélectionnés par tirage au sort transparent.',
    faq2q: 'Comment les gagnants sont-ils sélectionnés ?',
    faq2a: 'Les gagnants sont sélectionnés par un générateur de nombres aléatoires certifié. Chaque participation a une chance égale de gagner.',
    faq3q: 'Que se passe-t-il quand je gagne ?',
    faq3a: 'Nous vous notifierons immédiatement par email et téléphone. Votre prix sera expédié gratuitement sous 5-7 jours ouvrables.',
    faq4q: 'Y a-t-il une méthode de participation gratuite ?',
    faq4a: 'Oui ! Conformément à la loi britannique, vous pouvez participer gratuitement par voie postale. Détails dans nos Conditions Générales.',
    faq5q: 'Comment acheter des points ?',
    faq5a: 'Créez simplement un compte, accédez aux Packs de Points et choisissez celui qui vous convient.',
    faq6q: 'WINLUXOR est-il légitime ?',
    faq6a: 'Absolument. WINLUXOR est une société enregistrée au Royaume-Uni, opérant en pleine conformité avec la loi britannique sur les concours.',
    footerDesc: 'La plateforme de concours de luxe de référence au UK. Gagnez des prix extraordinaires.',
    quickLinks: 'Liens rapides',
    legal: 'Légal',
    support: 'Support',
    termsAndConditions: 'Conditions générales',
    privacyPolicy: 'Politique de confidentialité',
    cookiePolicy: 'Politique de cookies',
    responsiblePlay: 'Jeu responsable',
    allRightsReserved: 'Tous droits réservés.',
    ageDisclaimer: '18+ uniquement. Jouez de manière responsable.',
    welcomeBack: 'Bon retour',
    signInToAccount: 'Connectez-vous à votre compte WINLUXOR',
    email: 'Email',
    password: 'Mot de passe',
    dontHaveAccount: "Vous n'avez pas de compte ?",
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    createAccount: 'Créer un compte',
    joinWinluxor: 'Rejoignez WINLUXOR et gagnez des prix de luxe',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    city: 'Ville',
    postcode: 'Code postal',
    gender: 'Genre',
    dateOfBirth: 'Date de naissance',
    male: 'Homme',
    female: 'Femme',
    other: 'Autre',
    preferNotToSay: 'Préfère ne pas dire',
    creatingAccount: 'Création du compte...',
    signingIn: 'Connexion...',
    adminAccess: 'Accès administrateur',
    signInToAdmin: 'Connectez-vous au panel admin WINLUXOR',
    username: "Nom d'utilisateur",
    adminLogin: 'Connexion admin',
    backToDraws: 'Retour aux tirages',
    endsIn: 'Se termine dans',
    entriesSold: 'participations vendues',
    entriesRemaining: 'participations restantes',
    pointsPerEntry: 'points par entrée',
    confirmEntry: 'Confirmer la participation',
    enterTheDrawFor: 'Participer au tirage pour',
    pricePerEntry: 'Prix par entrée',
    quantity: 'Quantité',
    total: 'Total',
    yourBalance: 'Votre solde',
    insufficientPoints: 'Points insuffisants',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    processing: 'Traitement...',
    drawEnded: 'Tirage terminé',
    soldOut: 'Épuisé',
    details: 'Détails',
    shipping: 'Livraison',
    rules: 'Règles',
    shippingInfo: 'Tous les prix sont expédiés gratuitement sous 5-7 jours ouvrables. Livraison assurée au Royaume-Uni. Livraison internationale sur demande.',
    yourBalanceLabel: 'Votre crédit',
    points: '£',
    pointEquivalent: 'Votre crédit en livres sterling',
    transactionHistory: 'Historique des transactions',
    noTransactions: 'Aucune transaction pour le moment',
    credit: 'Crédit',
    debit: 'Débit',
    paymentComingSoon: 'Intégration de paiement bientôt ! Contactez l\'admin pour les points.',
    paymentInfo: 'Intégration de paiement bientôt. Contactez l\'admin pour créditer des points.',
    // Code promo (composant partagé)
    promoCodeLabel: 'Code promo',
    promoCodePlaceholder: 'BIENVENUE10',
    promoEmptyError: 'Veuillez entrer un code promo',
    promoApplied: 'Code promo appliqué !',
    promoCodeApplied: 'Code appliqué !',
    promoInvalid: 'Code promo invalide',
    promoDiscount: 'Remise',
    optional: 'facultatif',
    apply: 'Appliquer',
    type: 'Type',
    description: 'Description',
    amount: 'Montant',
    date: 'Date',
    myEntries: 'Mes participations',
    profile: 'Profil',
    noEntries: 'Aucune participation. Participez à un tirage pour commencer !',
    draw: 'Tirage',
    entries: 'Entrées',
    pointsSpent: 'Montant',
    profileDetails: 'Détails du profil',
    edit: 'Modifier',
    save: 'Enregistrer',
    saveChanges: 'Enregistrer les modifications',
    completeProfileTitle: 'Complétez votre profil',
    completeProfileDesc: 'Ajoutez votre téléphone et votre adresse pour finaliser vos participations et l\u2019envoi de vos lots.',
    completeProfileCta: 'Compléter',
    saving: 'Enregistrement...',
    profileUpdated: 'Profil mis à jour',
    referralCode: 'Votre code de parrainage',
    dashboard: 'Tableau de bord',
    raffles: 'Tirages',
    users: 'Utilisateurs',
    settings: 'Paramètres',
    backToSite: 'Retour au site',
    welcomeAdmin: 'Bienvenue, Admin',
    totalUsers: 'Utilisateurs totaux',
    activeRaffles: 'Tirages actifs',
    totalRaffles: 'Total tirages',
    totalEntries: 'Total participations',
    pointsInCirculation: 'Points en circulation',
    revenuePoints: 'Revenus (Points)',
    newRaffle: 'Nouveau tirage',
    manageDraws: 'Gérer vos tirages',
    title: 'Titre',
    tickets: 'Tickets',
    status: 'Statut',
    drawn: 'Tiré',
    actions: 'Actions',
    active: 'Actif',
    disabled: 'Désactivé',
    winnerDrawn: 'Gagnant tiré',
    newPack: 'Nouveau pack',
    managePacksDesc: 'Gérer les packs de points et les prix',
    name: 'Nom',
    price: 'Prix',
    popular: 'Populaire',
    enabled: 'Activé',
    settingsDesc: 'Configurer les fonctionnalités et paramètres',
    homepageSections: "Sections de la page d'accueil",
    activeDrawsSection: 'Section tirages actifs',
    pointPacksSection: 'Section packs de points',
    winnersSection: 'Section gagnants',
    urgencySection: 'Section urgence/marketing',
    howItWorksSection: 'Section Comment ça marche',
    trustSection: 'Section confiance',
    faqSection: 'Section FAQ',
    saveSettings: 'Sauvegarder',
    changeAdminPassword: 'Changer le mot de passe admin',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    updatePassword: 'Mettre à jour',
    platformInfo: 'Infos plateforme',
    currency: 'Devise',
    pointRate: 'Taux de points',
    adminUsername: "Nom d'utilisateur admin",
    creditDebitPoints: 'Créditer / Débiter des points',
    user: 'Utilisateur',
    currentBalance: 'Solde actuel',
    amountHelp: 'Montant (positif = crédit, négatif = débit)',
    reason: 'Raison',
    searchUsers: 'Rechercher...',
    manageUsersDesc: 'Gérer les utilisateurs et les points',
    role: 'Rôle',
    joined: 'Inscrit le',
    productValue: 'Valeur du produit',
    ticketCostPoints: 'Coût ticket (Points)',
    maxTickets: 'Tickets max',
    category: 'Catégorie',
    endDate: 'Date de fin',
    imageUrls: 'URLs images (une par ligne)',
    watches: 'Montres',
    handbags: 'Sacs à main',
    jewelry: 'Bijoux',
    electronics: 'Électronique',
    vehicles: 'Véhicules',
    update: 'Mettre à jour',
    create: 'Créer',
    editRaffle: 'Modifier le tirage',
    editPack: 'Modifier le pack',
    bonusPct: 'Bonus %',
    select: 'Sélectionner',
    showTicketsSold: 'Afficher les tickets vendus sur les tirages',
    winnersHistory: 'Gagnants & Historique',
    completedDraws: 'Tirages terminés',
    noCompletedDraws: 'Aucun tirage terminé pour le moment.',
    drawnOn: 'Tiré le',
    winner: 'Gagnant',
    questionRequired: 'Répondez à la question pour participer',
    answerQuestion: 'Répondre à la question',
    submitAnswer: 'Valider la réponse',
    incorrectAnswer: 'Réponse incorrecte. Veuillez réessayer.',
    vipLevel: 'Niveau VIP',
    vipBronze: 'Bronze',
    vipSilver: 'Argent',
    vipGold: 'Or',
    vipMember: 'Membre',
    applyReferral: 'Appliquer un code de parrainage',
    referralPlaceholder: 'Entrer le code de parrainage',
    apply: 'Appliquer',
    referralBonus: 'Bonus de parrainage',
    questionSetup: 'Question (Optionnel)',
    questionText: 'Question',
    answer: 'Réponse',
    correctAnswer: 'Bonne réponse',
    enableQuestion: 'Activer la question',
    referralBonusPoints: 'Bonus parrainage (Points)',
    ageVerificationTitle: 'Vérification de l\'âge',
    ageVerificationDesc: 'Vous devez avoir 18 ans ou plus pour accéder à ce site. En entrant, vous confirmez que vous remplissez la condition d\'âge minimum.',
    ageYes: 'Oui, j\'ai 18 ans ou plus',
    ageNo: 'Non, j\'ai moins de 18 ans',
    promoCodes: 'Codes Promo',
    managePromosDesc: 'Gérer les codes promotionnels et réductions',
    newPromo: 'Nouveau code promo',
    editPromo: 'Modifier le code promo',
    code: 'Code',
    discountPct: 'Réduction %',
    bonusPointsLabel: 'Points bonus',
    maxUses: 'Utilisations max',
    usedCount: 'Utilisé',
    unlimited: 'illimité',
    signupBonus: 'Bonus inscription (Points)',
    loyaltyBonusPct: 'Bonus fidélité %',
    totalParticipants: 'participations totales',
    myWins: 'Mes gains',
    noWins: 'Pas encore de gain. Continuez à participer !',
    notifications: 'Notifications',
    noNotifications: 'Aucune notification',
    unread: 'Non lu',
    // Contenu des notifications (par type)
    notifEntryTitle: 'Participation confirmée',
    notifEntryMessage: 'Vous avez participé à {{raffle}} avec {{qty}} ticket(s). Bonne chance !',
    notifNewRaffleTitle: 'Nouvelle Compétition !',
    notifNewRaffleMessage: '{{raffle}} — D\u2019une valeur de £{{value}}. Participez maintenant !',
    notifSpinTitle: 'Roue quotidienne',
    notifSpinMessage: 'Vous avez gagné {{reward}} points !',
    notifTestimonialApprovedTitle: '✨ Votre témoignage est maintenant public !',
    notifTestimonialApprovedMessage: 'Votre témoignage pour {{raffle}} a été approuvé et est désormais visible sur la page des gagnants.',
    notifTestimonialRejectedTitle: 'Merci de réécrire votre témoignage',
    notifTestimonialRejectedMessage: 'Votre témoignage pour {{raffle}} nécessite un petit ajustement. Veuillez le réécrire depuis votre compte.',
    notifTestimonialPendingTitle: '📝 Nouveau témoignage à valider',
    notifTestimonialPendingMessage: '{{firstName}} {{lastName}} a soumis un témoignage pour {{raffle}}.',
    videoUrl: 'URL Vidéo (YouTube/Vimeo)',
    dailySpin: 'Roue du jour',
    spinNow: 'Tourner',
    spinning: 'En cours...',
    spinRewardMsg: 'Revenez demain pour un autre tour !',
    liveChat: 'Chat en direct',
    liveChatDesc: 'Nous répondons généralement en quelques minutes',
    chatWelcome: 'Bonjour ! Comment pouvons-nous vous aider ?',
    typeMessage: 'Tapez un message...',
    share: 'Partager',
    analytics: 'Analytique',
    banners: 'Bannières',
    manageBannersDesc: 'Gérer les bannières promotionnelles',
    newBanner: 'Nouvelle bannière',
    userProfile: 'Fiche client',
    personalInfo: 'Informations personnelles',
    totalSpent: 'Total dépensé',
    referredBy: 'Parrainé par',
    referrals: 'Parrainages',
    close: 'Fermer',
    addressLine1: 'Adresse ligne 1',
    addressLine2: 'Adresse ligne 2',
    addressPlaceholder1: '123 Rue Principale',
    addressPlaceholder2: 'Appt 4, Bâtiment...',
    county: 'Département / Région',
    countryLabel: 'Pays',
    changePassword: 'Changer le mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    passwordUpdated: 'Mot de passe mis à jour avec succès',
    bothFieldsRequired: 'Tous les champs sont obligatoires',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordsMismatch: 'Les mots de passe ne correspondent pas',
    linkCopiedInstagram: 'Lien copié ! Collez-le dans votre story ou DM Instagram.',
    uploadImages: 'Importer des images',
    uploadImage: 'Importer',
    questionImage: 'Image de la question',
    pointRateLabel: 'Taux de points',
    pointRateHelp: 'Combien de points pour £1 ? (ex: 1 = 1pt/£1, 2 = 2pts/£1)',
    pointsPerPound: 'point(s) = £1',
    currentRate: 'Taux actuel',
    perEntry: 'par entrée',
    payWithPoints: 'Payer avec des points',
    payDirect: 'Payer directement (£)',
    directPaymentInfo: 'Intégration Stripe bientôt disponible.',
    stripeComingSoon: 'Intégration de paiement bientôt !',
    payNow: 'Payer maintenant',
    vip: 'VIP',
    vipExclusive: 'Exclusivité VIP',
    vipTitle: 'Débloquez les privilèges VIP',
    vipDesc: 'Rejoignez le club VIP pour des avantages exclusifs, un accès prioritaire aux nouveaux tirages et des points bonus mensuels.',
    yourSubscription: 'Votre abonnement',
    subscribe: "S'abonner maintenant",
    ptsPerMonth: '£/mois',
    month: 'mois',
    year: 'an',
    vipBenefitsTitle: 'Pourquoi devenir VIP ?',
    vipBenefit1Title: 'Points mensuels',
    vipBenefit1Desc: 'Recevez des points chaque mois, automatiquement.',
    vipBenefit2Title: 'Accès prioritaire',
    vipBenefit2Desc: 'Soyez le premier à participer aux nouveaux tirages.',
    vipBenefit3Title: 'Bonus sur les packs',
    vipBenefit3Desc: 'Pourcentage bonus supplémentaire sur tous les packs.',
    vipBenefit4Title: 'Statut VIP',
    vipBenefit4Desc: 'Badge VIP exclusif et reconnaissance.',
    vipMonthlyName: 'VIP Mensuel',
    vipAnnualName: 'VIP Annuel',
    vipBenefitMonthly1: '200 points/mois',
    vipBenefitAnnual1: '250 points/mois',
    vipBenefitPriority: 'Accès prioritaire aux nouveaux tirages',
    vipBenefitExclusive: 'Tirages VIP exclusifs',
    vipBenefitBonus10: '10% bonus sur les packs de points',
    vipBenefitBonus15: '15% bonus sur les packs de points',
    vipBenefitBirthday: 'Bonus anniversaire',
    vipPlans: 'Plans VIP',
    manageVipDesc: 'Gérer les abonnements VIP, prix et avantages',
    addPlan: 'Ajouter un plan',
    saveAll: 'Tout sauvegarder',
    planId: 'ID du plan',
    planName: 'Nom du plan',
    pointsPerMonth: 'Points / Mois',
    priceGbp: 'Prix (£)',
    benefitsList: 'Avantages',
    addBenefit: 'Ajouter',
    navigationMenu: 'Menu de navigation',
    navCompetitions: 'Lien Concours',
    navHowItWorks: 'Lien Comment ça marche',
    navWinnersMenu: 'Lien Gagnants',
    navVip: 'Lien VIP',
    ticketPackages: 'Packages de tickets',
    addPackage: 'Ajouter un package',
    qty: 'Qté',
    choosePackage: 'Choisissez un package',
    chanceToWin: 'chance de gagner',
    discount: 'Réduction',
    tickets: 'Tickets',
    pointsHistory: 'Historique du crédit',
    totalEarned: 'Total gagné',
    totalSpentPts: 'Total dépensé',
    currentBalanceShort: 'Solde',
    adminCredit: 'Crédit admin',
    adminDebit: 'Débit admin',
    raffleEntry: 'Achat ticket',
    dailySpinBonus: 'Roue du jour',
    referralBonusTx: 'Bonus parrainage',
    signupBonusTx: 'Bonus bienvenue',
    shareBonusTx: 'Bonus partage',
    // Descriptions de transactions (traduites côté client)
    txDescSignupBonus: 'Bonus de bienvenue',
    txDescEntry: 'Participation x{{qty}} — {{raffle}}',
    txDescReferralBonusCode: 'Bonus parrainage (code : {{code}})',
    txDescReferralBonusReferred: 'Bonus parrainage (filleul : {{email}})',
    txDescSpinReward: 'Récompense roue quotidienne : +{{reward}} pts',
    txDescShareBonus: 'Bonus de partage',
    txDescAdminCredit: 'Crédit admin',
    txDescAdminDebit: 'Débit admin',
    shareReferralInfo: 'Votre lien de parrainage est inclus !',
    shareEarnInfo: 'Votre code de parrainage est inclus. Vous gagnez des points quand quelqu\'un s\'inscrit via votre lien.',
    linkCopied: 'Lien copié !',
    referralBonusHelp: 'Points attribués au parrain et au filleul quand quelqu\'un s\'inscrit via un lien de parrainage.',
    spinWheel: 'Roue de la chance',
    manageSpinDesc: 'Configurer les prix, probabilités et fréquence',
    frequency: 'Fréquence',
    freqDaily: 'Une fois par jour',
    freq12h: 'Toutes les 12 heures',
    freq2days: 'Tous les 2 jours',
    freq3days: 'Tous les 3 jours',
    freqWeekly: 'Une fois par semaine',
    freqBiweekly: 'Toutes les 2 semaines',
    freqMonthly: 'Une fois par mois',
    totalSegments: 'Total segments',
    totalWeightLabel: 'Poids total',
    prizes: 'Prix',
    addPrize: 'Ajouter un prix',
    weight: 'Poids',
    probability: 'Probabilité',
    noSegments: 'Aucun segment configuré. Ajoutez des prix pour activer la roue.',
    newsletter: 'Newsletter',
    manageNewsletterDesc: 'Créer et envoyer des newsletters aux utilisateurs',
    newNewsletter: 'Nouvelle newsletter',
    noNewsletters: 'Aucune newsletter. Créez la première !',
    emailConfig: 'Config Email',
    fromEmail: 'Email expéditeur',
    sendgridHelp: 'Obtenez votre clé API sur sendgrid.com. Sans clé, les emails sont en file d\'attente mais non envoyés.',
    autoNotifications: 'Notifications automatiques',
    notifyNewRaffle: 'Notification nouveau tirage',
    notifyNewRaffleDesc: 'Envoyer automatiquement un email à tous les utilisateurs quand un nouveau tirage est créé',
    noSendgridWarning: 'Clé API SendGrid non configurée. Les emails sont en file d\'attente mais non envoyés. Ajoutez votre clé pour activer l\'envoi depuis newsletter@winluxor.com',
    subject: 'Objet',
    contentHtml: 'Contenu (HTML supporté)',
    templates: 'Modèles',
    preview: 'Aperçu',
    specifications: 'Caractéristiques',
    maxWinners: 'Gagnants maximum',
    maximumEntries: 'Participations maximum',
    specBrand: 'Marque',
    specModel: 'Modèle',
    specRefNumber: 'Numéro de référence',
    specMovement: 'Mouvement',
    specYear: 'Année',
    specCaliber: 'Calibre',
    specGlass: 'Verre',
    specBezelMaterial: 'Matériau lunette',
    specBraceletMaterial: 'Matériau bracelet',
    specPapers: 'Papiers & Boîte',
    specReference: 'Référence',
    specMaterial: 'Matériau',
    specColor: 'Couleur',
    specSize: 'Taille',
    specHardware: 'Quincaillerie',
    specType: 'Type (Bague, Collier...)',
    specStones: 'Pierres',
    specCarat: 'Carat',
    specCertification: 'Certification',
    specItemsIncluded: 'Articles inclus',
    specStorage: 'Stockage',
    specWarranty: 'Garantie',
    specDestination: 'Destination',
    specDuration: 'Durée',
    specHotel: 'Hôtel / Resort',
    specStars: 'Étoiles',
    specIncluded: 'Inclus (vols, repas...)',
    specDepartureFrom: 'Départ de',
    specValidUntil: 'Valable jusqu\'au',
    specEngine: 'Moteur',
    specMileage: 'Kilométrage',
    specTransmission: 'Transmission',
    specDetails: 'Détails',
  }
};

export default translations;
